<template>
    <section class="dp-layout">
        <section class="dp-left">
            <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1" />
        </section>

        <section class="dp-right">
            <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="[]" />

            <div class="config-panel">
                <!-- loading 占位 -->
                <div v-if="loading" class="loading-container" style="min-height: 300px;">
                    <div class="loading-content">
                        <i class="el-icon-loading" style="font-size: 32px; color: var(--btn-primary, #2563eb); margin-bottom: 10px;"></i>
                        <div class="loading-text">正在加载数据...</div>
                    </div>
                </div>

                <!-- 选中部门后显示 -->
                <div v-else-if="DepartmentId > 0" class="config-content">
                    <div class="config-page-head">
                        <div class="config-page-head__left">
                            <span class="config-page-head__eyebrow">德育规则配置</span>
                            <h2 class="config-page-head__title">{{ departmentName || ('学校 #' + DepartmentId) }}</h2>
                        </div>
                        <p class="config-page-head__hint">按模块分栏编辑，一屏只看一类配置</p>
                    </div>

                    <el-tabs v-model="activeConfigTab" stretch class="moral-config-tabs">
                    <el-tab-pane label="常规配置" name="general">
                    <!-- 模块一：常规配置 -->
                    <el-card class="config-card" shadow="never">
                        <div slot="header" class="card-header">
                            <span class="title">常规配置</span>
                            <div class="actions">
                                <el-button size="mini" type="primary" icon="el-icon-check" @click="saveConfig"
                                    :loading="saving">保存配置</el-button>
                            </div>
                        </div>

                        <el-form :model="form" label-width="110px" ref="formRef" size="small">
                            <!-- 全局设置 -->
                            <div class="sub-section">
                                <div class="inner-card general-bg compact-card">
                                    <div class="inner-title compact-title"><i class="el-icon-s-operation"></i> 基础显示
                                    </div>
                                    <div class="basic-grid">
                                        <div class="basic-grid-row">
                                            <div class="basic-grid-item">
                                                <span class="basic-item-label">检查记录老师</span>
                                                <el-radio-group v-model="form.ShowCheckTeacherName">
                                                    <el-radio :label="1">显示姓名</el-radio>
                                                    <el-radio :label="0">隐藏姓名</el-radio>
                                                </el-radio-group>
                                                <p class="mc-item-hint">控制检查记录中是否展示老师姓名</p>
                                            </div>
                                            <div class="basic-grid-item">
                                                <span class="basic-item-label">家长评分</span>
                                                <div class="basic-item-control">
                                                    <el-switch v-model="form.StudentEvaluationAllowParentRating"
                                                        active-text="允许" inactive-text="禁止"></el-switch>
                                                </div>
                                                <p class="mc-item-hint">开启后家长也可对学生进行点评</p>
                                            </div>
                                        </div>
                                        <div class="basic-grid-row">
                                            <div class="basic-grid-item basic-grid-item--full">
                                                <span class="basic-item-label">学生评价维度显示</span>
                                                <el-radio-group v-model="form.StudentEvaluationDimensionDisplayMode">
                                                    <el-radio label="Level1Only">仅显示一级类型</el-radio>
                                                    <el-radio label="Level1AndLevel2">显示一级和二级类型</el-radio>
                                                </el-radio-group>
                                                <p class="mc-item-hint">控制教师手机端点评页是否展示二级类型，未配置时保持原有“一级类型 → 评价项”展示</p>
                                            </div>
                                        </div>
                                        <div class="basic-grid-row">
                                            <div class="basic-grid-item basic-grid-item--full">
                                                <span class="basic-item-label">教师端评价默认</span>
                                                <el-radio-group v-model="form.StudentEvaluationTeacherDefaultTab">
                                                    <el-radio label="Praise">表扬</el-radio>
                                                    <el-radio label="Improvement">待改进</el-radio>
                                                </el-radio-group>
                                                <p class="mc-item-hint">教师手机端进入学生评价时默认选中的 Tab。未配置时默认表扬</p>
                                            </div>
                                        </div>
                                        <div class="basic-grid-row">
                                            <div class="basic-grid-item basic-grid-item--full">
                                                <span class="basic-item-label">手机端创建社团</span>
                                                <div class="basic-item-control">
                                                    <el-switch v-model="form.TeacherMobileAllowCreateOrganization"
                                                        active-text="允许" inactive-text="禁止"></el-switch>
                                                </div>
                                                <p class="mc-item-hint">开启后教师可在手机端创建/编辑本人管理的社团，并支持全量同步成员</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- 推送设置 -->
                            <div class="sub-section">
                                <div class="section-title"><i class="el-icon-bell" style="color:#E6A23C"></i> 点评分数变动推送设置</div>
                                <el-row :gutter="16">
                                    <el-col :span="12">
                                        <div class="inner-card class-bg compact-card">
                                            <div class="inner-title compact-title"><i
                                                    class="el-icon-office-building"></i> 班级通知</div>
                                            <div style="display: flex; flex-direction: column; gap: 12px; flex: 1;">
                                                <div
                                                    style="display: flex; flex-wrap: wrap; align-items: center; gap: 15px;">
                                                    <div style="display: flex; align-items: center;">
                                                        <span
                                                            style="color: #606266; font-size: 13px; margin-right: 8px;">模式</span>
                                                        <el-select v-model="form.ClassCheckScoreChangePushMode"
                                                            placeholder="请选择" size="mini" style="width: 110px;">
                                                            <el-option label="立即推送" :value="0"></el-option>
                                                            <el-option label="每天定时" :value="1"></el-option>
                                                            <el-option label="按周定时" :value="3"></el-option>
                                                            <el-option label="按月定时" :value="4"></el-option>
                                                            <el-option label="关闭通知" :value="2"></el-option>
                                                        </el-select>
                                                    </div>
                                                    <div style="display: flex; align-items: center;"
                                                        v-if="form.ClassCheckScoreChangePushMode === 1 || form.ClassCheckScoreChangePushMode === 3 || form.ClassCheckScoreChangePushMode === 4">
                                                        <span
                                                            style="color: #606266; font-size: 13px; margin-right: 8px;">时间</span>
                                                        <el-time-picker v-model="form.ClassCheckScoreChangePushTime"
                                                            placeholder="选择时间" format="HH:mm" value-format="HH:mm"
                                                            size="mini" style="width: 110px;" :clearable="false" />
                                                    </div>

                                                    <div
                                                        style="display: flex; align-items: center; border-left: 1px solid #dcdfe6; padding-left: 15px; margin-left: 5px;">
                                                        <span
                                                            style="color: #606266; font-size: 13px; margin-right: 8px;">推送值周老师</span>
                                                        <el-switch v-model="form.MoralScoreChangePushToDutyTeacher"
                                                            :disabled="form.ClassCheckScoreChangePushMode === 2"
                                                            size="mini"></el-switch>
                                                    </div>

                                                    <div v-if="form.ClassCheckScoreChangePushTaskId && form.ClassCheckScoreChangePushMode === 1"
                                                        style="font-size:12px; color:#909399; display: flex; align-items: center;">
                                                        <i class="el-icon-info"
                                                            style="margin-right: 5px;"></i>定时任务ID：<span
                                                            style="font-family:monospace; color:#67c23a; background: #e1f3d8; padding: 2px 6px; border-radius: 4px; margin-left: 4px;">{{
                                                                form.ClassCheckScoreChangePushTaskId }}</span>
                                                    </div>
                                                </div>

                                                <div style="display: flex; flex-wrap: wrap; align-items: center; gap: 15px;"
                                                    v-if="form.ClassCheckScoreChangePushMode === 3 || form.ClassCheckScoreChangePushMode === 4">
                                                    <div style="display: flex; align-items: center;"
                                                        v-if="form.ClassCheckScoreChangePushMode === 3">
                                                        <span
                                                            style="color: #606266; font-size: 13px; margin-right: 8px;">周期</span>
                                                        <el-select v-model="form.ClassCheckScoreChangePushWeekDay"
                                                            placeholder="选择周几" size="mini" style="width: 110px;">
                                                            <el-option v-for="d in weekDays" :key="d.value"
                                                                :label="d.label" :value="d.value" />
                                                        </el-select>
                                                    </div>
                                                    <div style="display: flex; align-items: center;"
                                                        v-if="form.ClassCheckScoreChangePushMode === 4">
                                                        <span
                                                            style="color: #606266; font-size: 13px; margin-right: 8px;">日期</span>
                                                        <el-tooltip content="0=首日, -1=末日, N=第N天" placement="top">
                                                            <el-input-number
                                                                v-model="form.ClassCheckScoreChangePushMonthDay"
                                                                :min="-1" :max="31" size="mini" style="width: 110px;"
                                                                controls-position="right" />
                                                        </el-tooltip>
                                                        <span
                                                            style="font-size:12px; color:#909399; margin-left:8px;">号</span>
                                                    </div>

                                                    <div v-if="form.ClassCheckScoreChangePushTaskId && (form.ClassCheckScoreChangePushMode === 3 || form.ClassCheckScoreChangePushMode === 4)"
                                                        style="font-size:12px; color:#909399; display: flex; align-items: center;">
                                                        <i class="el-icon-info"
                                                            style="margin-right: 5px;"></i>定时任务ID：<span
                                                            style="font-family:monospace; color:#67c23a; background: #e1f3d8; padding: 2px 6px; border-radius: 4px; margin-left: 4px;">{{
                                                                form.ClassCheckScoreChangePushTaskId }}</span>
                                                    </div>
                                                </div>

                                                <div
                                                    style="background: rgba(255,255,255,0.6); border-radius: 4px; padding: 8px 10px; margin-top: auto; font-size: 12px; color: #909399; line-height: 1.4; border: 1px dashed #e1f3d8;">
                                                    <span v-if="form.ClassCheckScoreChangePushMode === 0"><i
                                                            class="el-icon-lightning"
                                                            style="margin-right:2px; color:#E6A23C"></i>
                                                        点评产生后，系统将立即且毫无延迟地推送通知。</span>
                                                    <span v-else-if="form.ClassCheckScoreChangePushMode === 1"><i
                                                            class="el-icon-time"
                                                            style="margin-right:2px; color:var(--btn-primary, #2563eb)"></i>
                                                        每天到达设定时间时，汇总并推送当天的变动情况。</span>
                                                    <span v-else-if="form.ClassCheckScoreChangePushMode === 2"><i
                                                            class="el-icon-circle-close"
                                                            style="margin-right:2px; color:#F56C6C"></i>
                                                        已关闭此通知推送，产生变动时不会发送任何提醒。</span>
                                                    <span v-else-if="form.ClassCheckScoreChangePushMode === 3"><i
                                                            class="el-icon-date"
                                                            style="margin-right:2px; color:var(--btn-primary, #2563eb)"></i>
                                                        每周到达设定时间时，汇总并推送本周内的变动情况。</span>
                                                    <span v-else-if="form.ClassCheckScoreChangePushMode === 4"><i
                                                            class="el-icon-date"
                                                            style="margin-right:2px; color:var(--btn-primary, #2563eb)"></i>
                                                        每月到达设定时间时，汇总并推送本月内的变动情况。</span>
                                                </div>
                                            </div>
                                        </div>
                                    </el-col>
                                    <el-col :span="12">
                                        <div class="inner-card student-bg compact-card">
                                            <div class="inner-title compact-title"><i class="el-icon-user"></i> 学生通知
                                            </div>
                                            <div style="display: flex; flex-direction: column; gap: 12px; flex: 1;">
                                                <div
                                                    style="display: flex; flex-wrap: wrap; align-items: center; gap: 15px;">
                                                    <div style="display: flex; align-items: center;">
                                                        <span
                                                            style="color: #606266; font-size: 13px; margin-right: 8px;">模式</span>
                                                        <el-select v-model="form.StudentCheckScoreChangePushMode"
                                                            placeholder="请选择" size="mini" style="width: 110px;">
                                                            <el-option label="立即推送" :value="0"></el-option>
                                                            <el-option label="每天定时" :value="1"></el-option>
                                                            <el-option label="按周定时" :value="3"></el-option>
                                                            <el-option label="按月定时" :value="4"></el-option>
                                                            <el-option label="关闭通知" :value="2"></el-option>
                                                        </el-select>
                                                    </div>
                                                    <div style="display: flex; align-items: center;"
                                                        v-if="form.StudentCheckScoreChangePushMode === 1 || form.StudentCheckScoreChangePushMode === 3 || form.StudentCheckScoreChangePushMode === 4">
                                                        <span
                                                            style="color: #606266; font-size: 13px; margin-right: 8px;">时间</span>
                                                        <el-time-picker v-model="form.StudentCheckScoreChangePushTime"
                                                            placeholder="选择时间" format="HH:mm" value-format="HH:mm"
                                                            size="mini" style="width: 110px;" :clearable="false" />
                                                    </div>

                                                    <div v-if="form.StudentCheckScoreChangePushTaskId && form.StudentCheckScoreChangePushMode === 1"
                                                        style="font-size:12px; color:#909399; display: flex; align-items: center;">
                                                        <i class="el-icon-info"
                                                            style="margin-right: 5px;"></i>定时任务ID：<span
                                                            style="font-family:monospace; color:#e6a23c; background: #faecd8; padding: 2px 6px; border-radius: 4px; margin-left: 4px;">{{
                                                                form.StudentCheckScoreChangePushTaskId }}</span>
                                                    </div>
                                                </div>

                                                <div style="display: flex; flex-wrap: wrap; align-items: center; gap: 15px;"
                                                    v-if="form.StudentCheckScoreChangePushMode === 3 || form.StudentCheckScoreChangePushMode === 4">
                                                    <div style="display: flex; align-items: center;"
                                                        v-if="form.StudentCheckScoreChangePushMode === 3">
                                                        <span
                                                            style="color: #606266; font-size: 13px; margin-right: 8px;">周期</span>
                                                        <el-select v-model="form.StudentCheckScoreChangePushWeekDay"
                                                            placeholder="选择周几" size="mini" style="width: 110px;">
                                                            <el-option v-for="d in weekDays" :key="d.value"
                                                                :label="d.label" :value="d.value" />
                                                        </el-select>
                                                    </div>
                                                    <div style="display: flex; align-items: center;"
                                                        v-if="form.StudentCheckScoreChangePushMode === 4">
                                                        <span
                                                            style="color: #606266; font-size: 13px; margin-right: 8px;">日期</span>
                                                        <el-tooltip content="0=首日, -1=末日, N=第N天" placement="top">
                                                            <el-input-number
                                                                v-model="form.StudentCheckScoreChangePushMonthDay"
                                                                :min="-1" :max="31" size="mini" style="width: 110px;"
                                                                controls-position="right" />
                                                        </el-tooltip>
                                                        <span
                                                            style="font-size:12px; color:#909399; margin-left:8px;">号</span>
                                                    </div>

                                                    <div v-if="form.StudentCheckScoreChangePushTaskId && (form.StudentCheckScoreChangePushMode === 3 || form.StudentCheckScoreChangePushMode === 4)"
                                                        style="font-size:12px; color:#909399; display: flex; align-items: center;">
                                                        <i class="el-icon-info"
                                                            style="margin-right: 5px;"></i>定时任务ID：<span
                                                            style="font-family:monospace; color:#e6a23c; background: #faecd8; padding: 2px 6px; border-radius: 4px; margin-left: 4px;">{{
                                                                form.StudentCheckScoreChangePushTaskId }}</span>
                                                    </div>
                                                </div>

                                                <div
                                                    style="background: rgba(255,255,255,0.6); border-radius: 4px; padding: 8px 10px; margin-top: auto; font-size: 12px; color: #909399; line-height: 1.4; border: 1px dashed #faecd8;">
                                                    <span v-if="form.StudentCheckScoreChangePushMode === 0"><i
                                                            class="el-icon-lightning"
                                                            style="margin-right:2px; color:#E6A23C"></i>
                                                        点评产生后，系统将立即且毫无延迟地推送通知。</span>
                                                    <span v-else-if="form.StudentCheckScoreChangePushMode === 1"><i
                                                            class="el-icon-time"
                                                            style="margin-right:2px; color:var(--btn-primary, #2563eb)"></i>
                                                        每天到达设定时间时，汇总并推送当天的变动情况。</span>
                                                    <span v-else-if="form.StudentCheckScoreChangePushMode === 2"><i
                                                            class="el-icon-circle-close"
                                                            style="margin-right:2px; color:#F56C6C"></i>
                                                        已关闭此通知推送，产生变动时不会发送任何提醒。</span>
                                                    <span v-else-if="form.StudentCheckScoreChangePushMode === 3"><i
                                                            class="el-icon-date"
                                                            style="margin-right:2px; color:var(--btn-primary, #2563eb)"></i>
                                                        每周到达设定时间时，汇总并推送本周内的变动情况。</span>
                                                    <span v-else-if="form.StudentCheckScoreChangePushMode === 4"><i
                                                            class="el-icon-date"
                                                            style="margin-right:2px; color:var(--btn-primary, #2563eb)"></i>
                                                        每月到达设定时间时，汇总并推送本月内的变动情况。</span>
                                                </div>
                                            </div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-form>
                    </el-card>
                    </el-tab-pane>

                    <el-tab-pane label="高级策略" name="advanced">
                    <!-- 高级德育配置 (同步扣分 & 教师限额) -->
                    <el-card class="config-card" shadow="never">
                        <div slot="header" class="card-header">
                            <span class="title">高级德育策略</span>
                            <div class="actions">
                                <el-button size="mini" type="primary" icon="el-icon-check" @click="saveConfig"
                                    :loading="saving">保存配置</el-button>
                            </div>
                        </div>

                        <el-form :model="form" label-width="110px" size="small">
                            <!-- 第一行：德育业务模式（全宽） -->
                            <el-row class="mc-section-row">
                                <el-col :span="24">
                                    <div class="inner-card compact-card mode-bg">
                                        <div class="inner-title compact-title">
                                            <i class="el-icon-s-flag"></i> 德育业务模式
                                        </div>
                                        <el-row :gutter="20">
                                            <el-col :span="showMoralPhysicalCardConfigUi ? 12 : 24">
                                                <el-form-item label="业务模式" label-width="100px">
                                                    <el-radio-group v-model="form.MoralBizMode"
                                                        @change="onMoralBizModeChange">
                                                        <el-radio label="Standard">通用模式（默认）</el-radio>
                                                        <el-radio label="ZheshangWest">哲商模式</el-radio>
                                                    </el-radio-group>
                                                    <p class="mc-item-hint">通用：使用教师点评分值限制。哲商：管理员下发班级池；发分方式见下方选项。</p>
                                                </el-form-item>
                                            </el-col>
                                            <!-- 德育分实体卡：默认隐藏 UI，后端配置与保存仍带 MoralPointPhysicalCardEnabled；需展示时把 showMoralPhysicalCardConfigUi 改为 true -->
                                            <el-col v-if="showMoralPhysicalCardConfigUi" :span="12">
                                                <el-form-item label="德育分实体卡" label-width="110px">
                                                    <el-switch v-model="form.MoralPointPhysicalCardEnabled"
                                                        active-text="开启" inactive-text="关闭"></el-switch>
                                                    <p class="mc-item-hint">哲商模式默认关闭，避免实体卡与班级池账目冲突</p>
                                                </el-form-item>
                                            </el-col>
                                            <el-col v-if="form.MoralBizMode === 'ZheshangWest'" :span="24">
                                                <el-form-item label="发分方式" label-width="100px" class="zs-mode-form-item">
                                                    <div class="zs-mode-cards" role="radiogroup" aria-label="哲商发分方式">
                                                        <div
                                                            class="zs-mode-card"
                                                            role="radio"
                                                            tabindex="0"
                                                            :aria-checked="!form.MoralZheshangTeacherLimitForEval ? 'true' : 'false'"
                                                            :class="{ 'is-active': !form.MoralZheshangTeacherLimitForEval }"
                                                            @click="form.MoralZheshangTeacherLimitForEval = false"
                                                            @keydown.enter.prevent="form.MoralZheshangTeacherLimitForEval = false"
                                                            @keydown.space.prevent="form.MoralZheshangTeacherLimitForEval = false">
                                                            <div class="zs-mode-card__head">
                                                                <span class="zs-mode-card__radio" aria-hidden="true"></span>
                                                                <div class="zs-mode-card__titles">
                                                                    <div class="zs-mode-card__title">从班级池发分</div>
                                                                    <span class="zs-mode-card__badge">现网</span>
                                                                </div>
                                                            </div>
                                                            <ol class="zs-mode-card__steps">
                                                                <li><span class="zs-step-no">1</span>德育处下发班级池</li>
                                                                <li><span class="zs-step-no">2</span>班主任 / 任课从班级池或任课额度发分、点评</li>
                                                                <li><span class="zs-step-no">3</span>发到学生侧后形成可兑余额</li>
                                                                <li><span class="zs-step-no">4</span>再用可兑余额核销实体币</li>
                                                            </ol>
                                                        </div>
                                                        <div
                                                            class="zs-mode-card"
                                                            role="radio"
                                                            tabindex="0"
                                                            :aria-checked="form.MoralZheshangTeacherLimitForEval ? 'true' : 'false'"
                                                            :class="{ 'is-active': !!form.MoralZheshangTeacherLimitForEval }"
                                                            @click="form.MoralZheshangTeacherLimitForEval = true"
                                                            @keydown.enter.prevent="form.MoralZheshangTeacherLimitForEval = true"
                                                            @keydown.space.prevent="form.MoralZheshangTeacherLimitForEval = true">
                                                            <div class="zs-mode-card__head">
                                                                <span class="zs-mode-card__radio" aria-hidden="true"></span>
                                                                <div class="zs-mode-card__titles">
                                                                    <div class="zs-mode-card__title">按教师限额点评</div>
                                                                    <span class="zs-mode-card__badge zs-mode-card__badge--alt">班级池仅换币</span>
                                                                </div>
                                                            </div>
                                                            <ol class="zs-mode-card__steps">
                                                                <li><span class="zs-step-no">1</span>点评改走「教师点评分值限制」，不再受班级池额度限制</li>
                                                                <li><span class="zs-step-no">2</span>班级池仍由德育处下发</li>
                                                                <li><span class="zs-step-no">3</span>班主任拿到班级池分数后，直接到德育处换实体币</li>
                                                                <li><span class="zs-step-no">4</span>不再要求先把分发给学生，才能换币</li>
                                                            </ol>
                                                        </div>
                                                    </div>
                                                    <p class="mc-item-hint">点击卡片即可切换。选「按教师限额点评」时，点评扣右侧教师限额，班级池只用于下发与实体币核销。</p>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </div>
                                </el-col>
                            </el-row>

                            <!-- 第二行：学生评价同步扣班分 + 教师点评分值限制 -->
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <div class="inner-card rule-bg compact-card">
                                        <div class="inner-title-row">
                                            <div class="inner-title-content">
                                                <i class="el-icon-refresh"></i> 学生评价同步扣班分
                                            </div>
                                            <el-switch v-model="form.StudentEvaluationSyncClassScore"
                                                size="mini"></el-switch>
                                        </div>
                                        <div :class="{ 'is-disabled-content': !form.StudentEvaluationSyncClassScore }">
                                            <el-form-item label="扣分比例">
                                                <el-input-number v-model="form.StudentEvaluationSyncClassScoreRatio"
                                                    :min="0" :max="100" size="mini"
                                                    :disabled="!form.StudentEvaluationSyncClassScore"
                                                    style="width: 100px;"></el-input-number>
                                                <span style="font-size: 12px; color: #909399; margin-left: 5px;">%（学生人数
                                                    * 点评项分值）* N %</span>
                                            </el-form-item>
                                            <el-form-item label="保留小数">
                                                <el-switch v-model="form.StudentEvaluationSyncClassScoreKeepDecimal"
                                                    :disabled="!form.StudentEvaluationSyncClassScore"></el-switch>
                                            </el-form-item>
                                        </div>
                                        <p class="mc-item-hint">开启后，学生点评扣分可按比例同步扣班级分值</p>
                                    </div>
                                </el-col>

                                <el-col :span="12">
                                    <div class="inner-card action-bg compact-card">
                                        <div class="inner-title-row">
                                            <div class="inner-title-content">
                                                <i class="el-icon-warning-outline"></i> 教师点评分值限制
                                                <span v-if="form.MoralBizMode === 'ZheshangWest' && !form.MoralZheshangTeacherLimitForEval"
                                                    style="margin-left:8px;font-size:12px;color:#f56c6c;font-weight:normal;">
                                                    （哲商从池发分模式下不生效）
                                                </span>
                                                <span v-else-if="form.MoralBizMode === 'ZheshangWest' && form.MoralZheshangTeacherLimitForEval"
                                                    style="margin-left:8px;font-size:12px;color:#67c23a;font-weight:normal;">
                                                    （哲商已开启：按教师限额点评）
                                                </span>
                                            </div>
                                        </div>
                                        <div style="flex:1;display:flex;flex-direction:column;justify-content:center;">
                                            <el-form-item label="分值组配" label-width="80px">
                                                <el-button type="primary" size="mini" plain icon="el-icon-setting"
                                                    @click="handleManageTeacherGroups">管理 {{
                                                        teacherLimitGroups.length }} 个教师组</el-button>
                                            </el-form-item>
                                        </div>
                                        <p class="mc-item-hint">为教师组设置周期内最大加分上限（周：周一～周日；月：当月 1 号～月末）</p>
                                    </div>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-card>
                    </el-tab-pane>

                    <el-tab-pane label="积分商城" name="points">
                    <!-- 个人积分与德育商城（与 Department GetMoralConfig/SetMoralConfig 对齐；开启日结保存后由后端创建 Quartz 任务） -->
                    <el-card class="config-card moral-points-card" shadow="never">
                        <div slot="header" class="card-header">
                            <span class="title">个人积分与德育商城</span>
                            <div class="actions">
                                <el-button size="mini" type="primary" icon="el-icon-check" @click="saveConfig"
                                    :loading="saving">保存配置</el-button>
                            </div>
                        </div>

                        <el-form :model="form" label-width="122px" size="small" class="moral-points-form">
                            <el-row :gutter="16">
                                <el-col :span="12">
                                    <div class="inner-card points-bg compact-card points-panel">
                                        <div class="inner-title compact-title"><i class="el-icon-coin"></i> 日结与折算</div>
                                        <div class="moral-grid">
                                            <div class="moral-grid-row">
                                                <div class="moral-grid-item">
                                                    <div class="moral-grid-item__main">
                                                        <span class="moral-item-label">日结转积分</span>
                                                        <el-switch v-model="form.MoralPointDailyConversionEnabled"
                                                            active-text="开启" inactive-text="关闭" />
                                                    </div>
                                                    <p class="mc-item-hint">仅影响夜间折算，不改变点评德育分流水；班内日榜在结转成功后自动重算</p>
                                                </div>
                                            </div>
                                            <div class="moral-grid-row">
                                                <div class="moral-grid-item">
                                                    <div class="moral-grid-item__main">
                                                        <span class="moral-item-label">日结时刻</span>
                                                        <el-time-picker v-model="form.MoralPointSettlementTime"
                                                            format="HH:mm" value-format="HH:mm" placeholder="默认 20:00"
                                                            size="mini" class="moral-time-picker" :clearable="false" />
                                                    </div>
                                                    <p class="mc-item-hint">先按该时刻聚合德育分流水，再于 +10 分钟结转个人积分（当前结转 {{ getMoralPointConvertTimeText() }}）</p>
                                                </div>
                                            </div>
                                            <div class="moral-task-row"
                                                v-if="form.MoralPointDailyRollupTaskId || form.MoralPointConvertDailyTaskId">
                                                <span class="moral-item-label">定时任务 ID</span>
                                                <div class="tip-text moral-task-text">
                                                    <span v-if="form.MoralPointDailyRollupTaskId"
                                                        class="task-pill">聚合：<code>{{ form.MoralPointDailyRollupTaskId }}</code></span>
                                                    <span v-if="form.MoralPointConvertDailyTaskId"
                                                        class="task-pill">结转：<code>{{ form.MoralPointConvertDailyTaskId }}</code></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="12">
                                    <div class="inner-card points-bg compact-card points-panel">
                                        <div class="inner-title compact-title"><i class="el-icon-setting"></i> 扣分与兑换
                                        </div>
                                        <div class="moral-grid">
                                            <div class="moral-grid-row">
                                                <div class="moral-grid-item">
                                                    <div class="moral-grid-item__main">
                                                        <span class="moral-item-label">积分结转仅按加分</span>
                                                        <el-radio-group v-model="form.MoralDeductionNotSyncToPoints"
                                                            size="mini" class="mc-radio-pair">
                                                            <el-radio :label="false">否</el-radio>
                                                            <el-radio :label="true">是</el-radio>
                                                        </el-radio-group>
                                                    </div>
                                                    <p class="mc-item-hint">「是」时夜间只折加分、德育扣分不减积分；「否」时按净额折算</p>
                                                </div>
                                                <div class="moral-grid-item">
                                                    <div class="moral-grid-item__main">
                                                        <span class="moral-item-label">允许积分为负</span>
                                                        <el-switch v-model="form.AllowNegativeStudentPoints" />
                                                    </div>
                                                    <p class="mc-item-hint">关闭时积分最多扣到 0</p>
                                                </div>
                                            </div>
                                            <div class="moral-grid-row">
                                                <div class="moral-grid-item">
                                                    <div class="moral-grid-item__main">
                                                        <span class="moral-item-label">德育分卡核销须选教师</span>
                                                        <el-switch v-model="form.MoralExchangeRequireSelectTeacher" />
                                                    </div>
                                                    <p class="mc-item-hint">仅约束家长扫实体卡核销时须选择教师</p>
                                                </div>
                                            </div>
                                            <div class="moral-grid-row">
                                                <div class="moral-grid-item">
                                                    <div class="moral-grid-item__main">
                                                        <span class="moral-item-label">奖品须班主任确认</span>
                                                        <el-switch v-model="form.MoralClassReleaseRequireTeacherConfirm" />
                                                    </div>
                                                    <p class="mc-item-hint">开启后班级发放奖品需班主任确认后才能领取</p>
                                                </div>
                                                <div class="moral-grid-item">
                                                    <div class="moral-grid-item__main">
                                                        <span class="moral-item-label">代兑姓名脱敏</span>
                                                        <el-switch v-model="form.MoralMallTeacherExchangeMaskStudentName" />
                                                    </div>
                                                    <p class="mc-item-hint">教师代兑时对学生姓名做脱敏展示</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="12" style="margin-top: 10px;">
                                    <div class="inner-card points-bg compact-card points-panel">
                                        <div class="inner-title compact-title">
                                            <i class="el-icon-trophy"></i> 班内积分排行调度（周/月）
                                        </div>
                                        <div class="moral-grid">
                                            <div class="moral-grid-row moral-grid-row--rank-head">
                                                <div class="moral-grid-item">
                                                    <div class="moral-grid-item__main">
                                                        <span class="moral-item-label">周榜任务</span>
                                                        <el-switch v-model="form.MoralClassPointRankWeekJobEnabled"
                                                            active-text="开启" inactive-text="关闭"
                                                            :disabled="!form.MoralPointDailyConversionEnabled" />
                                                    </div>
                                                    <p class="mc-item-hint">须先开启「日结转积分」；按设定周几与时刻重算班内周榜</p>
                                                </div>
                                                <div class="moral-grid-item">
                                                    <div class="moral-grid-item__main">
                                                        <span class="moral-item-label">月榜任务</span>
                                                        <el-switch v-model="form.MoralClassPointRankMonthJobEnabled"
                                                            active-text="开启" inactive-text="关闭"
                                                            :disabled="!form.MoralPointDailyConversionEnabled" />
                                                    </div>
                                                    <p class="mc-item-hint">须先开启「日结转积分」；按设定日期与时刻重算班内月榜</p>
                                                </div>
                                            </div>
                                            <div class="moral-grid-row" v-if="form.MoralClassPointRankWeekJobEnabled">
                                                <div class="moral-grid-item">
                                                    <div class="moral-grid-item__main">
                                                        <span class="moral-item-label">周几执行</span>
                                                        <el-select v-model="form.MoralClassPointRankWeekDay" size="mini"
                                                            style="width: 120px;"
                                                            :disabled="!form.MoralPointDailyConversionEnabled">
                                                            <el-option v-for="d in weekDays" :key="d.value" :label="d.label"
                                                                :value="d.value" />
                                                        </el-select>
                                                    </div>
                                                </div>
                                                <div class="moral-grid-item">
                                                    <div class="moral-grid-item__main">
                                                        <span class="moral-item-label">时刻</span>
                                                        <el-time-picker v-model="form.MoralClassPointRankWeekTime"
                                                            format="HH:mm" value-format="HH:mm" placeholder="07:00"
                                                            size="mini" class="moral-time-picker" :clearable="false"
                                                            :disabled="!form.MoralPointDailyConversionEnabled" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="moral-grid-row" v-if="form.MoralClassPointRankMonthJobEnabled">
                                                <div class="moral-grid-item">
                                                    <div class="moral-grid-item__main">
                                                        <span class="moral-item-label">每月几日</span>
                                                        <el-input-number v-model="form.MoralClassPointRankMonthDay"
                                                            :min="-1" :max="28" size="mini" controls-position="right"
                                                            style="width: 130px;"
                                                            :disabled="!form.MoralPointDailyConversionEnabled" />
                                                    </div>
                                                    <p class="mc-item-hint">-1=末日，0=每月1日，1–28=固定日（短月兼容）</p>
                                                </div>
                                                <div class="moral-grid-item">
                                                    <div class="moral-grid-item__main">
                                                        <span class="moral-item-label">时刻</span>
                                                        <el-time-picker v-model="form.MoralClassPointRankMonthTime"
                                                            format="HH:mm" value-format="HH:mm" placeholder="07:00"
                                                            size="mini" class="moral-time-picker" :clearable="false"
                                                            :disabled="!form.MoralPointDailyConversionEnabled" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="moral-grid-row"
                                                v-if="form.MoralClassPointRankWeekTaskId || form.MoralClassPointRankMonthTaskId">
                                                <div class="moral-grid-item moral-grid-item--tip"
                                                    v-if="form.MoralClassPointRankWeekTaskId">
                                                    <span class="tip-text">周榜 Quartz
                                                        ID：<code>{{ form.MoralClassPointRankWeekTaskId }}</code></span>
                                                </div>
                                                <div class="moral-grid-item moral-grid-item--tip"
                                                    v-if="form.MoralClassPointRankMonthTaskId">
                                                    <span class="tip-text">月榜 Quartz
                                                        ID：<code>{{ form.MoralClassPointRankMonthTaskId }}</code></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="24" style="margin-top: 10px;">
                                    <div class="inner-card points-bg compact-card points-panel">
                                        <div class="inner-title compact-title">
                                            <i class="el-icon-data-line"></i> 按一级维度折算比例
                                        </div>
                                        <p class="mc-item-hint mc-item-hint--block">仅作用于夜间「点评流水」结转积分；德育分卡核销按 1:1，哲商发分见下方单独倍率</p>
                                        <div class="moral-grid">
                                            <div class="moral-grid-row">
                                                <div class="moral-grid-item moral-ratio-item">
                                                    <div v-if="form.MoralPointDimensionRatios && form.MoralPointDimensionRatios.length > 0"
                                                        class="moral-ratio-grid">
                                                        <div v-for="row in form.MoralPointDimensionRatios"
                                                            :key="row.DimensionId" class="moral-ratio-card">
                                                            <span class="moral-ratio-name">{{ row.DimensionName
                                                                }}</span>
                                                            <div class="moral-ratio-control">
                                                                <el-input-number v-model="row.Ratio" :precision="2"
                                                                    :step="0.1" :min="0.1" :max="100" size="mini"
                                                                    class="moral-ratio-input" />
                                                            </div>
                                                            <span class="tip-text moral-ratio-text">1 德育分 = {{
                                                                Number(row.Ratio || 1).toFixed(2) }} 积分</span>
                                                        </div>
                                                    </div>
                                                    <div v-else class="tip-text moral-ratio-empty">未找到一级点评维度，默认全维度 1:1
                                                        折算。</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col v-if="form.MoralBizMode === 'ZheshangWest'" :span="24"
                                    style="margin-top: 10px;">
                                    <div class="inner-card points-bg compact-card points-panel">
                                        <div class="inner-title compact-title">
                                            <i class="el-icon-present"></i> 哲商发分 → 个人积分倍率
                                        </div>
                                        <div class="moral-grid">
                                            <div class="moral-grid-row">
                                                <div class="moral-grid-item">
                                                    <div class="moral-grid-item__main">
                                                        <span class="moral-item-label">倍率（德育分 × N）</span>
                                                        <el-input-number v-model="form.MoralZheshangGrantToPointsRatio"
                                                            :precision="2" :step="0.1" :min="0.01" :max="100" size="mini"
                                                            style="width: 140px;" />
                                                    </div>
                                                    <p class="mc-item-hint">仅「哲商模式」且开启「日结转积分」时生效；对班级池/额度发到学生的德育分合计后乘倍率，再与「积分结转仅按加分」等规则合成</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-card>
                    </el-tab-pane>

                    <el-tab-pane label="流动红旗" name="redflag">
                    <!-- 流动红旗 -->
                    <el-card class="config-card flowing-red-flag-card" shadow="never">
                        <div slot="header" class="card-header frf-card-header">
                            <span class="title">流动红旗评选配置</span>
                            <div class="actions frf-header-actions">
                                <el-input
                                    v-model="frfGroupKeyword"
                                    size="mini"
                                    clearable
                                    prefix-icon="el-icon-search"
                                    placeholder="搜索分组 / 复核老师"
                                    class="frf-search-input"
                                    @input="onFrfGroupFilterChange" />
                                <el-select
                                    v-model="frfGroupModeFilter"
                                    size="mini"
                                    clearable
                                    placeholder="评选周期"
                                    class="frf-mode-filter"
                                    @change="onFrfGroupFilterChange">
                                    <el-option label="按周" :value="0" />
                                    <el-option label="按月" :value="1" />
                                </el-select>
                                <span class="frf-switch-label">
                                    功能开关：
                                    <el-switch v-model="form.FlowingRedFlagEnabled" @change="saveFlowingRedFlag"
                                        active-color="#13ce66"></el-switch>
                                </span>
                                <el-button size="mini" type="success" icon="el-icon-plus" @click="handleCreateGroup"
                                    :disabled="!form.FlowingRedFlagEnabled">新增分组</el-button>
                            </div>
                        </div>
                        <div class="group-list"
                            :style="{ opacity: form.FlowingRedFlagEnabled ? 1 : 0.6, pointerEvents: form.FlowingRedFlagEnabled ? 'auto' : 'none', transition: 'all 0.3s' }">
                            <div class="mc-section-hints frf-head-hints">
                                <p class="mc-item-hint">按周：统计上周周一 00:00:00～周日 23:59:59；按月：统计上月 1 号 00:00:00～月末 23:59:59。开启后：红旗生成前可改对应周期，生成后不可改、删、补录；关闭时仅允许操作本周数据。</p>
                            </div>
                            <el-table
                                ref="frfGroupsTable"
                                :data="pagedFlowingGroups"
                                border
                                size="medium"
                                height="320"
                                style="width: 100%"
                                class="custom-table frf-groups-table"
                                :header-cell-style="{ background: '#f5f7fa', color: '#606266', fontWeight: '600' }">
                                <el-table-column type="index" :index="frfGroupTableIndex" width="50" align="center" label="#"></el-table-column>
                                <el-table-column label="分组名称" width="120" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span style="font-weight: 500;">{{ scope.row.GroupName }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="评选周期" width="100" align="center">
                                    <template slot-scope="scope">
                                        <el-tag size="mini" :type="scope.row.Mode === 0 ? 'primary' : 'warning'">
                                            {{ scope.row.Mode === 0 ? '按周' : '按月' }}
                                        </el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column label="评选范围" min-width="150" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.Scope === 0">全校班级</span>
                                        <span v-else>指定班级 ({{ Array.isArray(scope.row.ScopeTargets) ?
                                            scope.row.ScopeTargets.length : 0 }}个)</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="获奖比例" width="120" align="center">
                                    <template slot-scope="scope">
                                        {{ scope.row.Percent }}%
                                        <el-tag v-if="scope.row.IncludeTies" size="mini" type="info"
                                            effect="plain">含并列</el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column label="复核老师" min-width="120" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ getTeacherNames(scope.row.ReviewTeacherIds) }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="定时评选" width="180">
                                    <template slot-scope="scope">
                                        <div v-if="scope.row.IsAutoPush">
                                            <span v-if="scope.row.Mode === 0">每周{{
                                                getWeekDayLabel(scope.row.PushWeekDay) }} {{ scope.row.PushTime
                                                }}</span>
                                            <span v-else>每月{{ getMonthDayLabel(scope.row.PushDayOfMonth) }} {{
                                                scope.row.PushTime }}</span>
                                            <div v-if="scope.row.TaskId" style="font-size: 11px; color: #909399;">ID: {{
                                                scope.row.TaskId }}</div>
                                        </div>
                                        <el-tag v-else type="info" size="mini">未开启定时评选</el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" width="180" align="center">
                                    <template slot-scope="scope">
                                        <div class="frf-op-actions">
                                            <el-button type="primary" icon="el-icon-edit" size="mini" plain
                                                class="frf-op-btn"
                                                @click="handleEditGroup(scope.row)"
                                                :disabled="!form.FlowingRedFlagEnabled">编辑</el-button>
                                            <el-button type="danger" icon="el-icon-delete" size="mini" plain
                                                class="frf-op-btn"
                                                @click="handleDeleteGroup(scope.row)"
                                                :disabled="!form.FlowingRedFlagEnabled">删除</el-button>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="frf-pagination">
                                <el-pagination
                                    background
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :current-page.sync="frfGroupPage"
                                    :page-size.sync="frfGroupPageSize"
                                    :page-sizes="[5, 10, 20, 50]"
                                    :total="filteredFlowingGroups.length"
                                    @size-change="onFrfGroupPageSizeChange" />
                            </div>
                        </div>
                    </el-card>
                    </el-tab-pane>

                    <el-tab-pane label="值日笑脸" name="smile">
                    <!-- 值日检查笑脸 -->
                    <el-card class="config-card" shadow="never">
                        <div slot="header" class="card-header">
                            <span class="title">值日检查笑脸</span>
                            <div class="actions">
                                <span class="duty-inspect-smile-switch-label">
                                    功能开关：
                                    <el-switch v-model="dutyInspectSmile.smileEnabled"
                                        active-color="#13ce66"></el-switch>
                                </span>
                                <el-button size="mini" type="primary" :loading="savingDutyInspectSmile"
                                    @click="saveDutyInspectSmileConfig">保存</el-button>
                            </div>
                        </div>
                        <div class="duty-inspect-smile-body" :class="{ 'is-disabled-content': !dutyInspectSmile.smileEnabled }">
                            <p class="mc-item-hint mc-item-hint--block">按「扣分」判档（扣分 = 满分 − 当周总分）；区间改动会联动后档（步长 0.1）</p>
                            <div class="inner-card compact-card duty-inspect-smile-schedule-card">
                                <div class="inner-title-row duty-inspect-smile-schedule-head">
                                    <div class="inner-title-content">
                                        <i class="el-icon-time" style="color: var(--btn-primary, #2563eb);"></i> 定时自动生成
                                    </div>
                                    <el-switch v-model="dutyInspectSmile.isAutoPush" size="mini"></el-switch>
                                </div>
                                <p class="mc-item-hint">开启后按设定周几与时刻统计上周并落库；关闭后不自动生成，档位与分值仍可保存</p>
                                <div v-if="dutyInspectSmile.isAutoPush" class="duty-inspect-smile-schedule-fields">
                                    <div class="flex-row duty-inspect-smile-schedule-row">
                                        <span class="prefix">每周</span>
                                        <el-select v-model="dutyInspectSmile.pushWeekDay" placeholder="周几"
                                            size="small" class="duty-inspect-smile-schedule-week">
                                            <el-option v-for="w in weekDays" :key="w.value" :label="w.label"
                                                :value="w.value"></el-option>
                                        </el-select>
                                        <el-time-picker v-model="dutyInspectSmile.pushTimeValue" format="HH:mm"
                                            value-format="HH:mm" placeholder="时间" size="small"
                                            class="duty-inspect-smile-schedule-time" :clearable="false">
                                        </el-time-picker>
                                    </div>
                                </div>
                            </div>
                            <div class="inner-card compact-card duty-inspect-smile-tier-card">
                                <div class="inner-title-row">
                                    <div class="inner-title-content">
                                        <i class="el-icon-s-data" style="color: #67c23a;"></i> 档位设置
                                    </div>
                                </div>
                                <p class="mc-item-hint">支持 3~5 档：名称 / 扣分区间 / 档位分值 / 图标</p>
                                <p v-if="dutyInspectSmileGapText"
                                    class="tip-text duty-inspect-smile-gap-tip">
                                    <i class="el-icon-warning-outline"></i>{{ dutyInspectSmileGapText }}
                                </p>
                                <div class="duty-inspect-smile-tier-list">
                                    <div v-for="(rule, index) in dutyInspectSmile.levelRules" :key="index"
                                        class="duty-inspect-smile-tier-row"
                                        :class="'duty-inspect-smile-tier-row--' + getSmileTierAccent(index)">
                                        <span class="duty-inspect-smile-tier-row__index">{{ index + 1 }}</span>
                                        <div class="duty-inspect-smile-tier-row__main">
                                            <div class="duty-inspect-smile-tier-row__field duty-inspect-smile-tier-row__field--name">
                                                <label>名称</label>
                                                <el-input v-model="rule.levelName" size="small" maxlength="12"
                                                    placeholder="如：绿脸"></el-input>
                                            </div>
                                            <div class="duty-inspect-smile-tier-row__field duty-inspect-smile-tier-row__field--range">
                                                <label>扣分区间</label>
                                                <div class="duty-inspect-smile-range">
                                                    <el-input-number v-model="rule.minScore" :step="0.1" :precision="2"
                                                        size="small" controls-position="right"
                                                        class="duty-inspect-smile-number"
                                                        @change="onDutyInspectSmileLevelRangeChange"></el-input-number>
                                                    <span class="duty-inspect-smile-range__sep">至</span>
                                                    <el-input-number v-model="rule.maxScore" :step="0.1" :precision="2"
                                                        size="small" controls-position="right"
                                                        class="duty-inspect-smile-number"
                                                        @change="onDutyInspectSmileLevelRangeChange"></el-input-number>
                                                </div>
                                            </div>
                                        <div class="duty-inspect-smile-tier-row__field duty-inspect-smile-tier-row__field--weight">
                                            <label>档位分值</label>
                                            <el-input-number v-model="rule.levelScore" :min="0.1" :step="0.5"
                                                :precision="2" size="small" controls-position="right"
                                                class="duty-inspect-smile-number duty-inspect-smile-number--weight"
                                                title="该档每周获评时计入的单周分数">
                                            </el-input-number>
                                        </div>
                                            <div class="duty-inspect-smile-tier-row__field duty-inspect-smile-tier-row__field--logo">
                                                <label>图标</label>
                                                <el-upload class="smile-avatar-uploader" action="#" :auto-upload="false"
                                                    accept="image/*" :show-file-list="false"
                                                    :on-change="(file) => handleSmileLogoChange(file, index)">
                                                    <img v-if="deferredImageDisplay(`smileLogo_${index}`, rule.logoUrl)"
                                                        v-oss-src="deferredImageDisplay(`smileLogo_${index}`, rule.logoUrl)" class="smile-avatar"
                                                        :alt="rule.levelName" />
                                                    <i v-else class="el-icon-plus smile-avatar-uploader-icon"></i>
                                                </el-upload>
                                            </div>
                                        </div>
                                        <el-button v-if="dutyInspectSmile.levelRules.length > 3" type="text"
                                            icon="el-icon-delete" class="duty-inspect-smile-tier-row__remove"
                                            @click="removeSmileLevel(index)"></el-button>
                                    </div>
                                </div>
                                <el-button v-if="dutyInspectSmile.levelRules.length < 5" size="small" type="primary"
                                    plain icon="el-icon-plus" class="duty-inspect-smile-add-btn"
                                    @click="addSmileLevel">新增档位</el-button>
                            </div>
                        </div>
                    </el-card>
                    </el-tab-pane>

                    <el-tab-pane label="成长树" name="growthtree">
                    <el-card class="config-card" shadow="never">
                        <div slot="header" class="card-header">
                            <span class="title">成长树阶段配置</span>
                            <div class="actions">
                                <el-button size="mini" @click="resetGrowthTreeDefaults">恢复默认</el-button>
                                <el-button size="mini" type="primary" :loading="savingGrowthTree"
                                    @click="saveGrowthTreeStageConfig">保存</el-button>
                            </div>
                        </div>
                        <p class="mc-item-hint mc-item-hint--block">
                            按「学期德育净分」命中阶段；净分下降允许降档。大屏月份筛选时成长树仍按学期累计。树图可点击更换，自定义后可恢复默认。
                        </p>
                        <div class="inner-card compact-card growth-tree-panel">
                            <div class="growth-tree-grid growth-tree-grid--head">
                                <span>阶段</span>
                                <span>阶段名称</span>
                                <span>最低学期净分</span>
                                <span>树图</span>
                            </div>
                            <div v-for="stage in growthTreeConfig.stages" :key="stage.stageIndex"
                                class="growth-tree-grid growth-tree-grid--row">
                                <span class="growth-tree-grid__idx">{{ stage.stageIndex }}</span>
                                <div class="growth-tree-grid__name">
                                    <el-input v-model="stage.stageName" size="small" maxlength="20"
                                        placeholder="如：萌芽期"></el-input>
                                </div>
                                <div class="growth-tree-grid__score">
                                    <el-input-number v-model="stage.minNetScore" :step="10" :precision="0"
                                        size="small" controls-position="right"
                                        :disabled="stage.stageIndex === 1"></el-input-number>
                                </div>
                                <div class="growth-tree-grid__tree">
                                    <el-upload class="growth-tree-uploader" action="#" :auto-upload="false"
                                        accept="image/png,image/jpeg,image/jpg,image/webp" :show-file-list="false"
                                        :on-change="(file) => handleGrowthTreeImageChange(file, stage.stageIndex)">
                                        <div class="growth-tree-thumb" :title="growthTreeStageUsesCustom(stage) ? '自定义图，点击更换' : '默认图，点击更换'">
                                            <img v-if="growthTreeStageUsesCustom(stage)"
                                                v-oss-src="deferredImageDisplay(`growthTree_${stage.stageIndex}`, stage.imageUrl)"
                                                class="growth-tree-preview" :alt="stage.stageName" />
                                            <img v-else :src="defaultGrowthTreeImageUrl(stage.stageIndex)"
                                                class="growth-tree-preview" :alt="stage.stageName" />
                                        </div>
                                    </el-upload>
                                    <el-button v-if="growthTreeStageUsesCustom(stage)" type="text" size="mini"
                                        class="growth-tree-reset-btn"
                                        @click="resetGrowthTreeStageImage(stage.stageIndex)">恢复</el-button>
                                </div>
                            </div>
                        </div>
                    </el-card>
                    </el-tab-pane>
                    </el-tabs>

                    <!-- 教师限额分组管理 Dialog -->
                    <el-dialog :visible.sync="teacherLimitVisible" width="700px" append-to-body>
                        <span slot="title">
                            教师点评限额组管理
                            <el-tooltip placement="top" effect="dark">
                                <div slot="content" class="mc-tip-content">
                                    <div>周期：每周=周一 00:00:00～周日 23:59:59</div>
                                    <div>每月=当月 1 号 00:00:00～当月最后一天 23:59:59</div>
                                </div>
                                <i class="el-icon-info mc-info-icon"></i>
                            </el-tooltip>
                        </span>
                        <div style="margin-bottom: 10px;">
                            <el-button type="primary" size="mini" icon="el-icon-plus" @click="addTeacherLimitGroup"
                                :disabled="teacherLimitGroups.length >= 20">添加分组 (最多20组)</el-button>
                        </div>
                        <el-table :data="teacherLimitGroupsPage" border stripe size="small">
                            <el-table-column label="组名" width="150">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.GroupName" size="mini" placeholder="如：班主任组"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="包含教师">
                                <template slot-scope="scope">
                                    <el-select v-model="scope.row.TeacherIds" multiple filterable collapse-tags
                                        placeholder="请选择教师" style="width: 100%" size="mini">
                                        <el-option v-for="t in teacherMasterList" :key="t.Id" :label="t.TeacherName"
                                            :value="t.Id" />
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column label="周期" width="100">
                                <template slot-scope="scope">
                                    <el-select v-model="scope.row.Period" size="mini" placeholder="周期">
                                        <el-option label="每周" value="Week"></el-option>
                                        <el-option label="每月" value="Month"></el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column label="上限分值" width="130">
                                <template slot-scope="scope">
                                    <el-input-number v-model="scope.row.MaxScore" :min="0" size="mini"
                                        controls-position="right" style="width: 100px;"></el-input-number>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="100" align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" style="color: #F56C6C" icon="el-icon-delete"
                                        @click="removeTeacherLimitGroup(scope.$index)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div style="margin-top: 12px; text-align: right;">
                            <el-pagination
                                v-if="teacherLimitVisible"
                                local-paging
                                background
                                layout="total, prev, pager, next"
                                :current-page.sync="teacherLimitPage"
                                :page-size="teacherLimitPageSize"
                                :total="teacherLimitGroups.length"
                            />
                        </div>
                        <div slot="footer">
                            <el-button size="small" @click="teacherLimitVisible = false">返回</el-button>
                            <el-button size="small" type="primary" @click="confirmTeacherLimitGroups">确定</el-button>
                        </div>
                    </el-dialog>

                    <!-- Group Configuration Dialog -->
                    <el-dialog :title="dialogTitle" :visible.sync="dialogGroupVisible" width="700px" append-to-body
                        :close-on-click-modal="false">
                        <el-form :model="tempGroup" label-width="100px" size="small">
                            <el-form-item label="分组名称">
                                <el-input v-model="tempGroup.GroupName" placeholder="请输入分组名称"></el-input>
                            </el-form-item>
                            <el-card class="group-config-dialog-card" shadow="never"
                                :body-style="{ padding: '12px 16px 4px' }">
                                <div slot="header" class="group-config-dialog-card__header">
                                    <i class="el-icon-s-flag group-config-dialog-card__icon group-config-dialog-card__icon--flag"
                                        style="color: #f56c6c;"></i>
                                    <span>评选规则</span>
                                </div>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="评选周期">
                                            <el-radio-group v-model="tempGroup.Mode" size="mini">
                                                <el-radio-button :label="0">按周评选</el-radio-button>
                                                <el-radio-button :label="1">按月评选</el-radio-button>
                                            </el-radio-group>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="获奖比例">
                                            <el-input-number v-model="tempGroup.Percent" :min="0" :max="100"
                                                controls-position="right" style="width: 100px" /> %
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-form-item label="同分规则">
                                    <el-checkbox v-model="tempGroup.IncludeTies" border
                                        size="mini">包含所有同分班级</el-checkbox>
                                </el-form-item>

                                <el-form-item label="评选范围">
                                    <el-radio-group v-model="tempGroup.Scope" style="margin-bottom: 10px;">
                                        <el-radio :label="0">全校班级</el-radio>
                                        <el-radio :label="1">指定班级</el-radio>
                                    </el-radio-group>
                                    <el-cascader v-if="tempGroup.Scope == 1" v-model="tempGroup.ScopeTargets"
                                        :options="classOptionsTree" :show-all-levels="false" collapse-tags
                                        :props="{ multiple: true }" placeholder="请选择参与评选的班级" clearable
                                        style="width: 100%">
                                    </el-cascader>
                                </el-form-item>
                            </el-card>

                            <!-- 流动红旗：定时自动生成评选任务 -->
                            <el-card class="group-config-dialog-card group-config-dialog-card--spaced" shadow="never"
                                :body-style="{ padding: '12px 16px 4px' }">
                                <div slot="header" class="group-config-dialog-card__header">
                                    <i class="el-icon-time group-config-dialog-card__icon group-config-dialog-card__icon--time"
                                        style="color: var(--btn-primary, #2563eb);"></i>
                                    <span>定时评选</span>
                                </div>
                                <el-form-item label="自动生成评选">
                                    <div>
                                        <el-switch v-model="tempGroup.IsAutoPush" active-text="开启"
                                            inactive-text="关闭"></el-switch>
                                        <div class="tip-xs" style="margin-top: 6px; color: #909399;">
                                            开启后，系统在下方设定的时间自动生成本组评选结果，并通知复核老师</div>
                                    </div>
                                </el-form-item>
                                <el-form-item label="执行时间" v-if="tempGroup.IsAutoPush">
                                    <!-- Week -->
                                    <div v-if="tempGroup.Mode == 0" class="flex-row">
                                        <span class="prefix">每周</span>
                                        <el-select v-model="tempGroup.PushWeekDay" placeholder="周几"
                                            style="width: 100px; margin: 0 10px;">
                                            <el-option v-for="d in weekDays" :key="d.value" :label="d.label"
                                                :value="d.value" />
                                        </el-select>
                                        <el-time-picker v-model="tempGroup.PushTime" format="HH:mm" value-format="HH:mm"
                                            style="width: 120px;" placeholder="时间" :clearable="false" />
                                    </div>
                                    <!-- Month -->
                                    <div v-if="tempGroup.Mode == 1" class="flex-row">
                                        <span class="prefix">每月</span>
                                        <el-tooltip content="0=首日, -1=末日, N=第N+1天" placement="top">
                                            <el-input-number v-model="tempGroup.PushDayOfMonth" :min="-1" :max="31"
                                                style="width: 100px; margin: 0 10px;" controls-position="right" />
                                        </el-tooltip>
                                        <span class="prefix">日</span>
                                        <el-time-picker v-model="tempGroup.PushTime" format="HH:mm" value-format="HH:mm"
                                            style="width: 120px; margin-left: 10px;" placeholder="时间"
                                            :clearable="false" />
                                    </div>
                                    <div v-if="tempGroup.Mode == 1" class="tip-xs"
                                        style="margin-top:5px; color:#909399">0: 首日, -1: 末日, 1:
                                        2日...</div>
                                </el-form-item>

                                <el-form-item label="复核老师">
                                    <el-select v-model="tempGroup.ReviewTeacherIds" multiple filterable collapse-tags
                                        placeholder="请选择复核老师" style="width: 100%">
                                        <el-option v-for="t in teacherMasterList" :key="t.Id" :label="t.TeacherName"
                                            :value="t.Id" />
                                    </el-select>
                                </el-form-item>
                            </el-card>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button @click="dialogGroupVisible = false">取消</el-button>
                            <el-button type="primary" @click="saveGroupData">确定</el-button>
                        </div>
                    </el-dialog>

                </div>

                <!-- 未选择部门提示 -->
                <div v-else class="no-department-tip">
                    <div style="text-align:center">
                        <i class="el-icon-school" style="font-size: 48px; color: #dcdfe6; margin-bottom: 20px;"></i>
                        <p>请在左侧选择一个部门以配置德育规则</p>
                    </div>
                </div>
            </div>
        </section>
    </section>
</template>

<script>
import { getMoralConfig, setMoralConfig, getFlowingRedFlagConfig, setFlowingRedFlagConfig, getDutyInspectSmileConfig, setDutyInspectSmileConfig, getGrowthTreeStageConfig, setGrowthTreeStageConfig, getSubDepartmentTree } from '../../api/modules/department';
import { getTeacherMasterList } from '../../api/modules/personnel';
import { getEvaluationDimensionParentsByDepartment } from '../../api/modules/moral-education';
import { BaseApiUrl } from '../../api/base';
import Toolbar from "../../components/Toolbar";
import DepartmentPane from "../../components/DepartmentPane";
import { publicAssetUrl } from '@/utils/publicAssetUrl';

export default {
    name: 'MoralConfig',
    components: { Toolbar, DepartmentPane },
    data() {
        return {
            buttonList: [],
            DepartmentId: 0,
            departmentName: '',
            /** 配置分栏：常规 / 高级 / 积分 / 红旗 / 笑脸 / 成长树。创建于 2026-09-02 */
            activeConfigTab: 'general',
            weeksData: [],
            weeksOptions: [],
            // 记录后端字段类型以便在保存时保持类型一致
            receivedTypes: {},
            savingFlow: false,
            savingDutyInspectSmile: false,
            savingGrowthTree: false,
            BaseApiUrl: BaseApiUrl,
            dutyInspectSmile: {
                smileEnabled: false,
                isAutoPush: false,
                pushWeekDay: 1,
                pushTimeValue: '08:00',
                levelRules: []
            },
            growthTreeConfig: {
                version: 1,
                stages: []
            },
            /** 流动红旗评选分组列表 */
            flowingGroups: [],
            /** 流动红旗分组搜索关键字。创建于 2026-03-16 */
            frfGroupKeyword: '',
            /** 流动红旗分组周期筛选：''全部 / 0按周 / 1按月 */
            frfGroupModeFilter: '',
            frfGroupPage: 1,
            frfGroupPageSize: 10,
            dialogGroupVisible: false,
            dialogTitle: '',
            editGroupIndex: -1,
            tempGroup: {
                Mode: 0,
                Scope: 0,
                ScopeTargets: [],
                Percent: 10,
                IncludeTies: false,
                PushWeekDay: 7,
                PushDayOfMonth: 0,
                PushTime: '08:00',
                ReviewTeacherIds: [],
                IsAutoPush: true,
                TaskId: null
            },
            weekDays: [
                { label: '周一', value: 1 },
                { label: '周二', value: 2 },
                { label: '周三', value: 3 },
                { label: '周四', value: 4 },
                { label: '周五', value: 5 },
                { label: '周六', value: 6 },
                { label: '周日', value: 7 },
            ],
            form: {
                // 基础显示
                ShowCheckTeacherName: 1,
                StudentEvaluationAllowParentRating: false,
                StudentEvaluationDimensionDisplayMode: 'Level1Only',
                StudentEvaluationTeacherDefaultTab: 'Praise',
                TeacherMobileAllowCreateOrganization: false,
                // 班级推送
                ClassCheckScoreChangePushMode: 0,
                ClassCheckScoreChangePushTime: '08:00',
                ClassCheckScoreChangePushTaskId: null,
                ClassCheckScoreChangePushWeekDay: 1,
                ClassCheckScoreChangePushMonthDay: 0,
                // 学生推送
                StudentCheckScoreChangePushMode: 0,
                StudentCheckScoreChangePushTime: '08:00',
                StudentCheckScoreChangePushTaskId: null,
                StudentCheckScoreChangePushWeekDay: 1,
                StudentCheckScoreChangePushMonthDay: 0,
                // 高级策略
                StudentEvaluationSyncClassScore: false,
                StudentEvaluationSyncClassScoreRatio: 0,
                StudentEvaluationSyncClassScoreKeepDecimal: false,
                TeacherEvaluationLimitGroups: '',
                // 流动红旗
                FlowingRedFlagEnabled: true,
                // 德育分推送
                MoralScoreChangePushToDutyTeacher: false,
                // 个人积分与德育商城
                MoralPointDailyConversionEnabled: false,
                MoralPointSettlementTime: '20:00',
                MoralPointDimensionRatios: [],
                MoralDeductionNotSyncToPoints: false,
                AllowNegativeStudentPoints: false,
                PointsDeductionFloorAtZero: true,
                MoralExchangeRequireSelectTeacher: false,
                MoralClassReleaseRequireTeacherConfirm: false,
                MoralMallTeacherExchangeMaskStudentName: false,
                MoralPointDailyRollupTaskId: '',
                MoralPointConvertDailyTaskId: '',
                MoralClassPointRankWeekJobEnabled: false,
                MoralClassPointRankWeekDay: 1,
                MoralClassPointRankWeekTime: '07:00',
                MoralClassPointRankWeekTaskId: '',
                MoralClassPointRankMonthJobEnabled: false,
                MoralClassPointRankMonthDay: 1,
                MoralClassPointRankMonthTime: '07:00',
                MoralClassPointRankMonthTaskId: '',
                // 业务模式（MoralBizMode / MoralPointPhysicalCardEnabled / MoralZheshangGrantToPointsRatio）
                MoralBizMode: 'Standard',
                MoralPointPhysicalCardEnabled: true,
                MoralZheshangGrantToPointsRatio: 1,
                MoralZheshangTeacherLimitForEval: false,
            },
            /** 是否展示「德育分实体卡」配置（默认 false 仅隐藏界面；加载/切换模式/保存仍处理 MoralPointPhysicalCardEnabled） */
            showMoralPhysicalCardConfigUi: false,
            loading: false,
            saving: false,
            teacherLimitVisible: false,
            teacherLimitGroups: [],
            /** 限额组弹窗分页：当前页。创建于 2026-09-05 */
            teacherLimitPage: 1,
            /** 限额组弹窗分页：每页条数 */
            teacherLimitPageSize: 8,
            // 级联选择器的树形选项（班级）
            classOptionsTree: [],
            // 教师下拉数据（用于复核老师选择）
            teacherMasterList: [],
            // 学生点评一级维度（用于配置德育分->积分折算比例）
            moralPointTopDimensions: [],
            // 后端回传的折算比例原文 JSON（等待维度加载后再落表单）
            moralPointRatioRawJson: '',
        };
    },
    computed: {
        /** 限额组弹窗当前页数据。创建于 2026-09-05 */
        teacherLimitGroupsPage() {
            const size = this.teacherLimitPageSize || 8;
            const page = Math.max(1, this.teacherLimitPage || 1);
            const start = (page - 1) * size;
            return (this.teacherLimitGroups || []).slice(start, start + size);
        },
        /** 流动红旗分组：按关键字与周期筛选。创建于 2026-03-16 */
        filteredFlowingGroups() {
            const list = this.flowingGroups || [];
            const keyword = (this.frfGroupKeyword || '').trim().toLowerCase();
            const modeFilter = this.frfGroupModeFilter;
            const hasModeFilter = modeFilter === 0 || modeFilter === 1 || modeFilter === '0' || modeFilter === '1';
            return list.filter(group => {
                if (hasModeFilter && Number(group.Mode) !== Number(modeFilter)) return false;
                if (!keyword) return true;
                const name = String(group.GroupName || '').toLowerCase();
                const teachers = String(this.getTeacherNames(group.ReviewTeacherIds) || '').toLowerCase();
                const scopeText = group.Scope === 0
                    ? '全校班级'
                    : `指定班级${Array.isArray(group.ScopeTargets) ? group.ScopeTargets.length : 0}`;
                return name.includes(keyword)
                    || teachers.includes(keyword)
                    || scopeText.toLowerCase().includes(keyword);
            });
        },
        /** 流动红旗分组：当前页数据。创建于 2026-03-16 */
        pagedFlowingGroups() {
            const size = this.frfGroupPageSize || 10;
            const page = Math.max(1, this.frfGroupPage || 1);
            const start = (page - 1) * size;
            return this.filteredFlowingGroups.slice(start, start + size);
        },
        /** 相邻档位之间存在空隙时提示（该区间仅排名、不判档） */
        dutyInspectSmileGapText() {
            const rules = (this.dutyInspectSmile && this.dutyInspectSmile.levelRules) || [];
            const gaps = [];
            for (let i = 0; i < rules.length - 1; i++) {
                const maxV = Number(rules[i].maxScore);
                const nextMin = Number(rules[i + 1].minScore);
                if (isNaN(maxV) || isNaN(nextMin) || nextMin <= maxV + 0.001) continue;
                const nameA = rules[i].levelName || `档位${i + 1}`;
                const nameB = rules[i + 1].levelName || `档位${i + 2}`;
                gaps.push(`${nameA}上限(${this.formatDeductScore(maxV)})与${nameB}下限(${this.formatDeductScore(nextMin)})`);
            }
            if (!gaps.length) return '';
            return `扣分在 ${gaps.join('、')} 之间有空隙，该区间的班级仅排名、不判档。`;
        },
    },
    watch: {
        'form.ClassCheckScoreChangePushMode'(newVal) {
            if (newVal === 2) {
                this.form.MoralScoreChangePushToDutyTeacher = false;
            }
        },
        'form.AllowNegativeStudentPoints'(newVal) {
            // 前端仅保留“是否允许负分”一个配置项；兼容后端历史字段，自动联动“扣到0”。
            this.form.PointsDeductionFloorAtZero = !newVal;
        },
        'form.MoralPointDailyConversionEnabled'(enabled) {
            if (!enabled) {
                this.form.MoralClassPointRankWeekJobEnabled = false;
                this.form.MoralClassPointRankMonthJobEnabled = false;
            }
        },
        /** 切到流动红旗时重算表格高度，否则表体可能无法滚动。创建于 2026-03-16 */
        activeConfigTab(val) {
            if (val !== 'redflag') return;
            this.$nextTick(() => {
                this.relayoutFrfGroupsTable();
            });
        },
        pagedFlowingGroups() {
            this.$nextTick(() => {
                this.relayoutFrfGroupsTable();
            });
        }
    },
    methods: {
        /** 触发流动红旗表格 doLayout，恢复表体内滚动 */
        relayoutFrfGroupsTable() {
            const table = this.$refs.frfGroupsTable;
            if (table && typeof table.doLayout === 'function') {
                table.doLayout();
            }
        },
        addMinutesToTime(timeText, deltaMinutes) {
            const text = timeText || '20:00';
            const parts = text.split(':');
            const h = parts.length > 0 ? Number(parts[0]) : NaN;
            const m = parts.length > 1 ? Number(parts[1]) : NaN;
            if (Number.isNaN(h) || Number.isNaN(m)) return '20:10';
            const total = h * 60 + m + (Number(deltaMinutes) || 0);
            if (total < 0 || total > 1439) return '超出当日';
            const hh = Math.floor(total / 60);
            const mm = total % 60;
            return `${String(hh).padStart(2, '0')}:${String(mm).padStart(2, '0')}`;
        },
        getMoralPointConvertTimeText() {
            return this.addMinutesToTime(this.form.MoralPointSettlementTime, 10);
        },
        treeNodeClick(data) {
            this.DepartmentId = data.value;
            this.departmentName = data.label || '';
            this.activeConfigTab = 'general';
            this.loading = true;
            Promise.all([
                this.loadMoralConfig(this.DepartmentId),
                this.loadMoralPointTopDimensions(this.DepartmentId),
                this.loadFlowingRedFlag(this.DepartmentId),
                this.loadDutyInspectSmileConfig(this.DepartmentId),
                this.loadGrowthTreeStageConfig(this.DepartmentId),
                this.loadSubDepartments(this.DepartmentId),
                this.getTeacherMasters(this.DepartmentId),
            ]).then(() => {
                // 配置和班级树都加载完成后，将后端ID列表映射为级联路径
                this.mapAllGroupsTargets();
            }).finally(() => {
                this.loading = false;
            });
        },

        onMoralBizModeChange(val) {
            // 切换到哲商模式时默认关闭实体卡；切回通用模式时默认开启
            if (val === 'ZheshangWest') {
                this.form.MoralPointPhysicalCardEnabled = false;
            } else {
                this.form.MoralPointPhysicalCardEnabled = true;
                this.form.MoralZheshangTeacherLimitForEval = false;
            }
        },

        loadMoralConfig(departmentId) {
            if (!departmentId) return Promise.resolve();
            return getMoralConfig({ departmentId }).then(res => {
                if (res && res.data && res.data.success) {
                    const resp = res.data.response || {};

                    // 基础显示逻辑修复 (Boolean -> 1/0)
                    if (typeof resp.ShowCheckTeacherName === 'boolean') {
                        this.form.ShowCheckTeacherName = resp.ShowCheckTeacherName ? 1 : 0;
                    } else if (resp.ShowCheckTeacherName !== undefined && resp.ShowCheckTeacherName !== null) {
                        this.form.ShowCheckTeacherName = Number(resp.ShowCheckTeacherName);
                    } else {
                        this.form.ShowCheckTeacherName = 1;
                    }

                    this.form.StudentEvaluationAllowParentRating = !!resp.StudentEvaluationAllowParentRating;
                    this.form.StudentEvaluationDimensionDisplayMode =
                        resp.StudentEvaluationDimensionDisplayMode === 'Level1AndLevel2'
                            ? 'Level1AndLevel2'
                            : 'Level1Only';
                    this.form.StudentEvaluationTeacherDefaultTab =
                        resp.StudentEvaluationTeacherDefaultTab === 'Improvement'
                            ? 'Improvement'
                            : 'Praise';
                    this.form.TeacherMobileAllowCreateOrganization = !!resp.TeacherMobileAllowCreateOrganization;

                    // 班级推送设置
                    this.form.ClassCheckScoreChangePushMode = resp.ClassCheckScoreChangePushMode !== undefined ? resp.ClassCheckScoreChangePushMode : 0;
                    this.form.ClassCheckScoreChangePushTime = resp.ClassCheckScoreChangePushTime || '08:00';
                    this.form.ClassCheckScoreChangePushTaskId = resp.ClassCheckScoreChangePushTaskId || null;
                    this.form.ClassCheckScoreChangePushWeekDay = resp.ClassCheckScoreChangePushWeekDay !== undefined ? resp.ClassCheckScoreChangePushWeekDay : 1;
                    this.form.ClassCheckScoreChangePushMonthDay = resp.ClassCheckScoreChangePushMonthDay !== undefined ? resp.ClassCheckScoreChangePushMonthDay : 0;

                    // 学生推送设置
                    this.form.StudentCheckScoreChangePushMode = resp.StudentCheckScoreChangePushMode !== undefined ? resp.StudentCheckScoreChangePushMode : 0;
                    this.form.StudentCheckScoreChangePushTime = resp.StudentCheckScoreChangePushTime || '08:00';
                    this.form.StudentCheckScoreChangePushTaskId = resp.StudentCheckScoreChangePushTaskId || null;
                    this.form.StudentCheckScoreChangePushWeekDay = resp.StudentCheckScoreChangePushWeekDay !== undefined ? resp.StudentCheckScoreChangePushWeekDay : 1;
                    this.form.StudentCheckScoreChangePushMonthDay = resp.StudentCheckScoreChangePushMonthDay !== undefined ? resp.StudentCheckScoreChangePushMonthDay : 0;

                    // 高级策略
                    this.form.StudentEvaluationSyncClassScore = !!resp.StudentEvaluationSyncClassScore;
                    this.form.StudentEvaluationSyncClassScoreRatio = resp.StudentEvaluationSyncClassScoreRatio !== undefined ? resp.StudentEvaluationSyncClassScoreRatio : 0;
                    this.form.StudentEvaluationSyncClassScoreKeepDecimal = !!resp.StudentEvaluationSyncClassScoreKeepDecimal;

                    this.form.TeacherEvaluationLimitGroups = resp.TeacherEvaluationLimitGroups || '';
                    this.form.MoralScoreChangePushToDutyTeacher = !!resp.MoralScoreChangePushToDutyTeacher;

                    // 日结涉及定时任务：未配置/未返回时默认关闭，避免误以为已开启
                    this.form.MoralPointDailyConversionEnabled = resp.MoralPointDailyConversionEnabled === true;
                    this.form.MoralPointSettlementTime = resp.MoralPointSettlementTime || '20:00';
                    this.moralPointRatioRawJson = typeof resp.MoralPointDimensionRatioJson === 'string'
                        ? resp.MoralPointDimensionRatioJson
                        : '';
                    this.form.MoralDeductionNotSyncToPoints = !!resp.MoralDeductionNotSyncToPoints;
                    this.form.AllowNegativeStudentPoints = !!resp.AllowNegativeStudentPoints;
                    this.form.PointsDeductionFloorAtZero = !this.form.AllowNegativeStudentPoints;
                    this.form.MoralExchangeRequireSelectTeacher = !!resp.MoralExchangeRequireSelectTeacher;
                    this.form.MoralClassReleaseRequireTeacherConfirm = !!resp.MoralClassReleaseRequireTeacherConfirm;
                    this.form.MoralMallTeacherExchangeMaskStudentName = !!resp.MoralMallTeacherExchangeMaskStudentName;
                    this.form.MoralPointDailyRollupTaskId = resp.MoralPointDailyRollupTaskId || '';
                    this.form.MoralPointConvertDailyTaskId = resp.MoralPointConvertDailyTaskId || '';
                    this.form.MoralClassPointRankWeekJobEnabled = !!resp.MoralClassPointRankWeekJobEnabled;
                    this.form.MoralClassPointRankWeekDay = resp.MoralClassPointRankWeekDay !== undefined ? resp.MoralClassPointRankWeekDay : 1;
                    this.form.MoralClassPointRankWeekTime = resp.MoralClassPointRankWeekTime || '07:00';
                    this.form.MoralClassPointRankWeekTaskId = resp.MoralClassPointRankWeekTaskId || '';
                    this.form.MoralClassPointRankMonthJobEnabled = !!resp.MoralClassPointRankMonthJobEnabled;
                    this.form.MoralClassPointRankMonthDay = resp.MoralClassPointRankMonthDay !== undefined ? resp.MoralClassPointRankMonthDay : 1;
                    this.form.MoralClassPointRankMonthTime = resp.MoralClassPointRankMonthTime || '07:00';
                    this.form.MoralClassPointRankMonthTaskId = resp.MoralClassPointRankMonthTaskId || '';
                    // 业务模式与实体卡
                    this.form.MoralBizMode = resp.MoralBizMode || 'Standard';
                    this.form.MoralPointPhysicalCardEnabled = resp.MoralPointPhysicalCardEnabled !== false;
                    const zsRatio = Number(resp.MoralZheshangGrantToPointsRatio);
                    this.form.MoralZheshangGrantToPointsRatio = !Number.isNaN(zsRatio) && zsRatio > 0 ? zsRatio : 1;
                    this.form.MoralZheshangTeacherLimitForEval = !!resp.MoralZheshangTeacherLimitForEval
                        || !!resp.ZheshangEvalUsesTeacherLimit;
                    if (!this.form.MoralPointDailyConversionEnabled) {
                        this.form.MoralClassPointRankWeekJobEnabled = false;
                        this.form.MoralClassPointRankMonthJobEnabled = false;
                    }

                    try {
                        let groups = this.form.TeacherEvaluationLimitGroups ? JSON.parse(this.form.TeacherEvaluationLimitGroups) : [];
                        groups.forEach(g => {
                            if (!g.Period) g.Period = 'Week';
                            // 兼容性处理：如果旧数据只有 TeacherNames 而没有 TeacherIds
                            if (!g.TeacherIds && g.TeacherNames) {
                                g.TeacherIds = [];
                                g.TeacherNames.forEach(name => {
                                    const t = this.teacherMasterList.find(tm => tm.TeacherName === name);
                                    if (t) g.TeacherIds.push(t.Id);
                                });
                            }
                            if (!g.TeacherIds) g.TeacherIds = [];
                        });
                        this.teacherLimitGroups = groups;
                    } catch (e) {
                        this.teacherLimitGroups = [];
                    }

                    this.syncMoralPointDimensionRatios();
                }
            }).catch(() => {
                this.$message && this.$message.error && this.$message.error('加载德育配置失败');
            });
        },
        loadMoralPointTopDimensions(departmentId) {
            if (!departmentId) return Promise.resolve();
            return getEvaluationDimensionParentsByDepartment({ departmentId }).then(res => {
                if (res && res.data && res.data.success) {
                    const rows = Array.isArray(res.data.response) ? res.data.response : [];
                    this.moralPointTopDimensions = rows
                        .filter(x => x && Number(x.Id) > 0)
                        .map(x => ({
                            Id: Number(x.Id),
                            Name: x.Name || `维度${x.Id}`
                        }));
                    this.syncMoralPointDimensionRatios();
                }
            }).catch(() => {
                this.moralPointTopDimensions = [];
            });
        },
        parseMoralPointRatioMap(rawJson) {
            const ratioMap = {};
            if (!rawJson) return ratioMap;
            try {
                const arr = JSON.parse(rawJson);
                if (!Array.isArray(arr)) return ratioMap;
                arr.forEach(item => {
                    const dimensionId = Number(item && item.DimensionId);
                    const ratio = Number(item && item.Ratio);
                    if (dimensionId > 0) {
                        ratioMap[dimensionId] = ratio > 0 ? ratio : 1;
                    }
                });
            } catch (e) {
                return {};
            }
            return ratioMap;
        },
        syncMoralPointDimensionRatios() {
            if (!Array.isArray(this.moralPointTopDimensions) || this.moralPointTopDimensions.length === 0) {
                this.form.MoralPointDimensionRatios = [];
                return;
            }

            const ratioMap = this.parseMoralPointRatioMap(this.moralPointRatioRawJson);
            this.form.MoralPointDimensionRatios = this.moralPointTopDimensions.map(d => ({
                DimensionId: d.Id,
                DimensionName: d.Name,
                Ratio: ratioMap[d.Id] > 0 ? ratioMap[d.Id] : 1
            }));
        },

        getTeacherMasters(id) {
            if (!id) return Promise.resolve();
            const par = { departmentId: id };
            return getTeacherMasterList(par).then((res) => {
                if (res && res.data && res.data.response) {
                    this.teacherMasterList = res.data.response;
                }
                return res;
            }).catch(() => {
                this.teacherMasterList = [];
            });
        },

        saveConfig() {
            if (!this.DepartmentId) {
                this.$message.warning('请先选择部门');
                return;
            }
            if (this.form.MoralPointDailyConversionEnabled) {
                const settleTime = this.form.MoralPointSettlementTime || '20:00';
                const settleParts = settleTime.split(':');
                const settleHour = settleParts.length > 0 ? Number(settleParts[0]) : NaN;
                const settleMinute = settleParts.length > 1 ? Number(settleParts[1]) : NaN;
                const settleTotalMinutes = (Number.isNaN(settleHour) || Number.isNaN(settleMinute))
                    ? -1
                    : settleHour * 60 + settleMinute;
                // 规则：结转时刻=日结时刻+10分钟，且必须同日，故日结时刻上限 23:49
                if (settleTotalMinutes < 0 || settleTotalMinutes > 1429) {
                    this.$message.warning('日结时刻需在同日 00:00-23:49，结转时刻固定为其后10分钟');
                    return;
                }
            }
            if (!this.form.MoralPointDailyConversionEnabled && (this.form.MoralClassPointRankWeekJobEnabled || this.form.MoralClassPointRankMonthJobEnabled)) {
                this.$message.warning('须先开启「日结转积分」，才能启用班内周榜或月榜');
                return;
            }
            if (this.form.MoralPointDailyConversionEnabled && this.form.MoralClassPointRankWeekJobEnabled) {
                const wd = Number(this.form.MoralClassPointRankWeekDay);
                if (!wd || wd < 1 || wd > 7) {
                    this.$message.warning('班内积分周榜：请选择周一至周日');
                    return;
                }
            }
            if (this.form.MoralPointDailyConversionEnabled && this.form.MoralClassPointRankMonthJobEnabled) {
                const md = Number(this.form.MoralClassPointRankMonthDay);
                if (Number.isNaN(md) || md < -1 || md > 28) {
                    this.$message.warning('班内积分月榜：执行日须为 -1（末日）、0（首日）或 1–28');
                    return;
                }
            }
            this.saving = true;

            // 如果后端某些旧接口强制要求 boolean，则转换；否则传 0/1。目前保持 0/1 以匹配 load 逻辑。
            const showCheckVal = Number(this.form.ShowCheckTeacherName);

            const needTime = [1, 3, 4].includes(this.form.ClassCheckScoreChangePushMode);
            const studentNeedTime = [1, 3, 4].includes(this.form.StudentCheckScoreChangePushMode);

            const payload = {
                departmentId: this.DepartmentId,
                ShowCheckTeacherName: showCheckVal,
                StudentEvaluationAllowParentRating: !!this.form.StudentEvaluationAllowParentRating,
                StudentEvaluationDimensionDisplayMode: this.form.StudentEvaluationDimensionDisplayMode === 'Level1AndLevel2'
                    ? 'Level1AndLevel2'
                    : 'Level1Only',
                StudentEvaluationTeacherDefaultTab: this.form.StudentEvaluationTeacherDefaultTab === 'Improvement'
                    ? 'Improvement'
                    : 'Praise',
                TeacherMobileAllowCreateOrganization: !!this.form.TeacherMobileAllowCreateOrganization,
                ClassCheckScoreChangePushMode: Number(this.form.ClassCheckScoreChangePushMode),
                ClassCheckScoreChangePushTime: needTime ? (this.form.ClassCheckScoreChangePushTime || '08:00') : '',
                ClassCheckScoreChangePushTaskId: this.form.ClassCheckScoreChangePushTaskId || null,
                ClassCheckScoreChangePushWeekDay: Number(this.form.ClassCheckScoreChangePushWeekDay) || 1,
                ClassCheckScoreChangePushMonthDay: Number(this.form.ClassCheckScoreChangePushMonthDay) || 0,
                StudentCheckScoreChangePushMode: Number(this.form.StudentCheckScoreChangePushMode),
                StudentCheckScoreChangePushTime: studentNeedTime ? (this.form.StudentCheckScoreChangePushTime || '08:00') : '',
                StudentCheckScoreChangePushTaskId: this.form.StudentCheckScoreChangePushTaskId || null,
                StudentCheckScoreChangePushWeekDay: Number(this.form.StudentCheckScoreChangePushWeekDay) || 1,
                StudentCheckScoreChangePushMonthDay: Number(this.form.StudentCheckScoreChangePushMonthDay) || 0,
                StudentEvaluationSyncClassScore: !!this.form.StudentEvaluationSyncClassScore,
                StudentEvaluationSyncClassScoreRatio: Number(this.form.StudentEvaluationSyncClassScoreRatio),
                StudentEvaluationSyncClassScoreKeepDecimal: !!this.form.StudentEvaluationSyncClassScoreKeepDecimal,
                TeacherEvaluationLimitGroups: JSON.stringify(this.teacherLimitGroups),
                MoralScoreChangePushToDutyTeacher: !!this.form.MoralScoreChangePushToDutyTeacher,
                MoralPointDailyConversionEnabled: !!this.form.MoralPointDailyConversionEnabled,
                MoralPointSettlementTime: this.form.MoralPointSettlementTime || '20:00',
                MoralPointDimensionRatioJson: JSON.stringify(
                    (this.form.MoralPointDimensionRatios || []).map(x => ({
                        DimensionId: Number(x.DimensionId),
                        Ratio: Number(x.Ratio) > 0 ? Number(x.Ratio) : 1
                    }))
                ),
                MoralDeductionNotSyncToPoints: !!this.form.MoralDeductionNotSyncToPoints,
                AllowNegativeStudentPoints: !!this.form.AllowNegativeStudentPoints,
                PointsDeductionFloorAtZero: !this.form.AllowNegativeStudentPoints,
                MoralExchangeRequireSelectTeacher: !!this.form.MoralExchangeRequireSelectTeacher,
                MoralClassReleaseRequireTeacherConfirm: !!this.form.MoralClassReleaseRequireTeacherConfirm,
                MoralMallTeacherExchangeMaskStudentName: !!this.form.MoralMallTeacherExchangeMaskStudentName,
                MoralClassPointRankWeekJobEnabled: !!this.form.MoralClassPointRankWeekJobEnabled,
                MoralClassPointRankWeekDay: Number(this.form.MoralClassPointRankWeekDay) || 1,
                MoralClassPointRankWeekTime: this.form.MoralClassPointRankWeekTime || '07:00',
                MoralClassPointRankMonthJobEnabled: !!this.form.MoralClassPointRankMonthJobEnabled,
                MoralClassPointRankMonthDay: Number(this.form.MoralClassPointRankMonthDay),
                MoralClassPointRankMonthTime: this.form.MoralClassPointRankMonthTime || '07:00',
                SyncMoralClassPointRankSchedule: true,
                MoralBizMode: this.form.MoralBizMode || 'Standard',
                MoralPointPhysicalCardEnabled: !!this.form.MoralPointPhysicalCardEnabled,
                MoralZheshangGrantToPointsRatio: (() => {
                    const n = Number(this.form.MoralZheshangGrantToPointsRatio);
                    return !Number.isNaN(n) && n > 0 ? n : 1;
                })(),
                MoralZheshangTeacherLimitForEval: !!this.form.MoralZheshangTeacherLimitForEval,
            };
            setMoralConfig(payload).then(res => {
                this.saving = false;
                if (res && res.data && res.data.success) {
                    this.$message.success('保存成功');
                    // 重新加载以反映服务器生成的任何任务ID
                    this.loadMoralConfig(this.DepartmentId);
                } else {
                    this.$message.error((res && res.data && res.data.msg) || '保存失败');
                }
            }).catch(() => {
                this.saving = false;
                this.$message.error('保存失败，请稍后重试');
            });
        },

        callFunction(item) {
            // 工具栏操作占位符
        },

        formatDeductScore(value) {
            const n = Number(value);
            if (isNaN(n)) return '0';
            return n.toFixed(2).replace(/\.?0+$/, '') || '0';
        },
        roundDeductScore(value) {
            const n = Number(value);
            if (isNaN(n)) return 0;
            return Math.round(n * 100) / 100;
        },
        /** 联动校正各档扣分上下限，保证相邻档位不重叠且后档下限跟随前档上限（步长 0.1） */
        syncDutyInspectSmileLevelRanges() {
            const step = 0.1;
            const rules = (this.dutyInspectSmile && this.dutyInspectSmile.levelRules) || [];
            if (!rules.length) return false;

            const snapshot = () => rules.map(r =>
                `${this.roundDeductScore(r.minScore)},${this.roundDeductScore(r.maxScore)}`).join('|');
            const before = snapshot();

            let prevMax = null;
            rules.forEach((rule, index) => {
                let min = Number(rule.minScore);
                let max = Number(rule.maxScore);
                if (isNaN(min)) min = 0;
                if (isNaN(max)) max = 0;

                if (index === 0) {
                    min = Math.max(0, min);
                } else if (prevMax != null && min <= prevMax) {
                    min = this.roundDeductScore(prevMax + step);
                }
                if (max < min) max = min;

                rule.minScore = this.roundDeductScore(min);
                rule.maxScore = this.roundDeductScore(max);
                prevMax = rule.maxScore;
            });

            return snapshot() !== before;
        },
        onDutyInspectSmileLevelRangeChange() {
            if (this.syncDutyInspectSmileLevelRanges()) {
                this.$message.info('已联动调整相邻档位阈值');
            }
        },
        defaultSmileLevelRules() {
            return [
                { levelCode: 'green', levelName: '绿脸', minScore: 0, maxScore: 0, levelScore: 2, logoUrl: '' },
                { levelCode: 'yellow', levelName: '黄脸', minScore: 0.01, maxScore: 0.5, levelScore: 1.5, logoUrl: '' },
                { levelCode: 'red', levelName: '红脸', minScore: 0.6, maxScore: 999, levelScore: 1, logoUrl: '' }
            ];
        },
        mapSmileLevelFromApi(row) {
            if (!row) return null;
            return {
                levelCode: row.LevelCode || row.levelCode || '',
                levelName: row.LevelName || row.levelName || '',
                minScore: row.MinScore != null ? row.MinScore : (row.minScore != null ? row.minScore : 0),
                maxScore: row.MaxScore != null ? row.MaxScore : (row.maxScore != null ? row.maxScore : 0),
                levelScore: row.LevelScore != null ? row.LevelScore : (row.levelScore != null ? row.levelScore : 1),
                logoUrl: row.LogoUrl || row.logoUrl || ''
            };
        },
        loadDutyInspectSmileConfig(departmentId) {
            if (!departmentId) return Promise.resolve();
            return getDutyInspectSmileConfig({ departmentId }).then(res => {
                if (res && res.data && res.data.success) {
                    const resp = res.data.response || {};
                    const rules = resp.Rules || resp.rules || {};
                    const levelRaw = rules.LevelRules || rules.levelRules || [];
                    let levelRules = (levelRaw || []).map(r => this.mapSmileLevelFromApi(r)).filter(Boolean);
                    if (!levelRules.length) levelRules = this.defaultSmileLevelRules();
                    this.dutyInspectSmile = {
                        smileEnabled: !!(resp.SmileEnabled !== undefined ? resp.SmileEnabled : resp.smileEnabled),
                        isAutoPush: !!(rules.IsAutoPush !== undefined ? rules.IsAutoPush : rules.isAutoPush),
                        pushWeekDay: rules.PushWeekDay != null ? rules.PushWeekDay : (rules.pushWeekDay != null ? rules.pushWeekDay : 1),
                        pushTimeValue: rules.PushTime || rules.pushTime || '08:00',
                        levelRules
                    };
                    this.$nextTick(() => {
                        this.syncDutyInspectSmileLevelRanges();
                        (this.dutyInspectSmile.levelRules || []).forEach((r, i) => {
                            this.deferredImageInit(`smileLogo_${i}`, r.logoUrl)
                        })
                    });
                }
            }).catch(() => {
                this.$message && this.$message.error && this.$message.error('加载值日检查笑脸配置失败');
            });
        },
        saveDutyInspectSmileConfig() {
            if (!this.DepartmentId) {
                this.$message.warning('请先选择学校');
                return Promise.reject();
            }
            const s = this.dutyInspectSmile;
            if (!s.levelRules || s.levelRules.length < 3 || s.levelRules.length > 5) {
                this.$message.warning('档位数量须在 3~5 个之间');
                return Promise.reject();
            }
            this.syncDutyInspectSmileLevelRanges();
            for (let i = 0; i < s.levelRules.length; i++) {
                const r = s.levelRules[i];
                if (Number(r.minScore) > Number(r.maxScore)) {
                    this.$message.warning(`请检查「${r.levelName || '档位' + (i + 1)}」：扣分下限不能大于上限`);
                    return Promise.reject();
                }
            }
            for (let i = 0; i < s.levelRules.length - 1; i++) {
                if (Number(s.levelRules[i].maxScore) >= Number(s.levelRules[i + 1].minScore)) {
                    this.$message.warning('相邻档位扣分区间不能重叠，请检查上下限');
                    return Promise.reject();
                }
            }
            this.savingDutyInspectSmile = true;
            const ensureLogos = async () => {
                for (let i = 0; i < s.levelRules.length; i++) {
                    s.levelRules[i].logoUrl = await this.deferredImageEnsure(`smileLogo_${i}`, {
                        foo: 'dutyInspectSmile',
                        currentUrl: s.levelRules[i].logoUrl
                    })
                }
            }
            return ensureLogos().then(() => {
            const payload = {
                DepartmentId: this.DepartmentId,
                SmileEnabled: !!s.smileEnabled,
                Rules: {
                    IsAutoPush: !!s.isAutoPush,
                    PushWeekDay: s.pushWeekDay,
                    PushTime: s.pushTimeValue || '08:00',
                    LevelRules: s.levelRules.map((r, idx) => ({
                        LevelCode: r.levelCode || `level${idx + 1}`,
                        LevelName: r.levelName,
                        MinScore: r.minScore,
                        MaxScore: r.maxScore,
                        LevelScore: r.levelScore,
                        LogoUrl: r.logoUrl || ''
                    }))
                }
            };
            return setDutyInspectSmileConfig(payload).then(res => {
                if (res && res.data && res.data.success) {
                    this.$message.success('值日检查笑脸配置已保存');
                    return this.loadDutyInspectSmileConfig(this.DepartmentId);
                }
                this.$message.error((res && res.data && res.data.msg) || '保存失败');
                return Promise.reject();
            }).catch(() => {
                this.$message.error('保存失败');
                return Promise.reject();
            }).finally(() => {
                this.savingDutyInspectSmile = false;
            });
            });
        },
        /** 默认成长树 6 档。创建于 2026-09-02 */
        defaultGrowthTreeStages() {
            return [
                { stageIndex: 1, stageName: '萌芽期', minNetScore: 0, imageUrl: '' },
                { stageIndex: 2, stageName: '小树苗', minNetScore: 200, imageUrl: '' },
                { stageIndex: 3, stageName: '生长期', minNetScore: 350, imageUrl: '' },
                { stageIndex: 4, stageName: '拔节期', minNetScore: 500, imageUrl: '' },
                { stageIndex: 5, stageName: '开花期', minNetScore: 650, imageUrl: '' },
                { stageIndex: 6, stageName: '果实累累', minNetScore: 800, imageUrl: '' }
            ];
        },
        defaultGrowthTreeImageUrl(stageIndex) {
            return publicAssetUrl(`static/zheshang-big-screen/tree/${stageIndex}.png`);
        },
        growthTreeStageUsesCustom(row) {
            const key = `growthTree_${row.stageIndex}`;
            const pending = this.deferredImagePending[key];
            if (pending && pending.previewUrl) return true;
            return !!(row.imageUrl && String(row.imageUrl).trim());
        },
        mapGrowthTreeStageFromApi(row, index) {
            const stageIndex = row.StageIndex != null ? row.StageIndex : (row.stageIndex != null ? row.stageIndex : index + 1);
            return {
                stageIndex,
                stageName: row.StageName || row.stageName || '',
                minNetScore: row.MinNetScore != null ? Number(row.MinNetScore) : (row.minNetScore != null ? Number(row.minNetScore) : 0),
                imageUrl: row.ImageUrl || row.imageUrl || ''
            };
        },
        loadGrowthTreeStageConfig(departmentId) {
            if (!departmentId) return Promise.resolve();
            return getGrowthTreeStageConfig({ departmentId }).then(res => {
                if (res && res.data && res.data.success) {
                    const resp = res.data.response || {};
                    const config = resp.Config || resp.config || {};
                    const stagesRaw = config.Stages || config.stages || [];
                    let stages = (stagesRaw || []).map((r, i) => this.mapGrowthTreeStageFromApi(r, i));
                    if (stages.length !== 6) stages = this.defaultGrowthTreeStages();
                    this.growthTreeConfig = {
                        version: config.Version != null ? config.Version : (config.version != null ? config.version : 1),
                        stages
                    };
                    this.$nextTick(() => {
                        (this.growthTreeConfig.stages || []).forEach((stage) => {
                            this.deferredImageInit(`growthTree_${stage.stageIndex}`, stage.imageUrl || '');
                        });
                    });
                } else {
                    this.growthTreeConfig = { version: 1, stages: this.defaultGrowthTreeStages() };
                }
            }).catch(() => {
                this.growthTreeConfig = { version: 1, stages: this.defaultGrowthTreeStages() };
                this.$message && this.$message.error && this.$message.error('加载成长树配置失败');
            });
        },
        resetGrowthTreeDefaults() {
            for (let i = 1; i <= 6; i++) this.deferredImageRevoke(`growthTree_${i}`);
            this.growthTreeConfig = { version: 1, stages: this.defaultGrowthTreeStages() };
        },
        resetGrowthTreeStageImage(stageIndex) {
            const stage = (this.growthTreeConfig.stages || []).find(item => item.stageIndex === stageIndex);
            if (!stage) return;
            this.deferredImageRevoke(`growthTree_${stageIndex}`);
            stage.imageUrl = '';
        },
        handleGrowthTreeImageChange(file, stageIndex) {
            const stage = (this.growthTreeConfig.stages || []).find(item => item.stageIndex === stageIndex);
            if (!stage) return;
            this.deferredImageChange(`growthTree_${stageIndex}`, file, { foo: 'growthTree', savedUrl: stage.imageUrl || '' });
        },
        saveGrowthTreeStageConfig() {
            if (!this.DepartmentId) {
                this.$message.warning('请先选择学校');
                return Promise.reject();
            }
            const stages = (this.growthTreeConfig.stages || []).slice().sort((a, b) => a.stageIndex - b.stageIndex);
            if (stages.length !== 6) {
                this.$message.warning('成长树必须配置恰好 6 档');
                return Promise.reject();
            }
            for (let i = 0; i < stages.length; i++) {
                const stage = stages[i];
                if (stage.stageIndex !== i + 1) {
                    this.$message.warning('阶段序号必须为 1～6');
                    return Promise.reject();
                }
                if (!stage.stageName || !String(stage.stageName).trim()) {
                    this.$message.warning(`第 ${stage.stageIndex} 档阶段名称不能为空`);
                    return Promise.reject();
                }
                if (i > 0 && Number(stage.minNetScore) <= Number(stages[i - 1].minNetScore)) {
                    this.$message.warning('各档最低净分必须严格递增');
                    return Promise.reject();
                }
            }
            this.savingGrowthTree = true;
            const ensureImages = async () => {
                for (let i = 0; i < stages.length; i++) {
                    const stage = stages[i];
                    stage.imageUrl = await this.deferredImageEnsure(`growthTree_${stage.stageIndex}`, {
                        foo: 'growthTree',
                        currentUrl: stage.imageUrl || ''
                    });
                }
            };
            return ensureImages().then(() => {
                const payload = {
                    DepartmentId: this.DepartmentId,
                    Config: {
                        Version: this.growthTreeConfig.version || 1,
                        Stages: stages.map(s => ({
                            StageIndex: s.stageIndex,
                            StageName: String(s.stageName).trim(),
                            MinNetScore: Number(s.minNetScore),
                            ImageUrl: s.imageUrl || ''
                        }))
                    }
                };
                return setGrowthTreeStageConfig(payload).then(res => {
                    if (res && res.data && res.data.success) {
                        this.$message.success('成长树配置已保存');
                        return this.loadGrowthTreeStageConfig(this.DepartmentId);
                    }
                    this.$message.error((res && res.data && res.data.msg) || '保存失败');
                    return Promise.reject();
                });
            }).catch(() => {
                this.$message.error('树图上传或保存失败');
                return Promise.reject();
            }).finally(() => {
                this.savingGrowthTree = false;
            });
        },
        addSmileLevel() {
            if (this.dutyInspectSmile.levelRules.length >= 5) return;
            const n = this.dutyInspectSmile.levelRules.length + 1;
            const rules = this.dutyInspectSmile.levelRules;
            const last = rules[rules.length - 1];
            const prevMax = last ? Number(last.maxScore) : 0;
            rules.push({
                levelCode: `custom${n}`,
                levelName: `档位${n}`,
                minScore: this.roundDeductScore((isNaN(prevMax) ? 0 : prevMax) + 0.1),
                maxScore: this.roundDeductScore((isNaN(prevMax) ? 0 : prevMax) + 0.2),
                levelScore: 1,
                logoUrl: ''
            });
            this.syncDutyInspectSmileLevelRanges();
        },
        removeSmileLevel(index) {
            if (this.dutyInspectSmile.levelRules.length <= 3) return;
            this.dutyInspectSmile.levelRules.splice(index, 1);
        },
        handleSmileLogoChange(file, index) {
            const rule = this.dutyInspectSmile.levelRules[index]
            if (!rule) return
            this.deferredImageChange(`smileLogo_${index}`, file, { foo: 'dutyInspectSmile', savedUrl: rule.logoUrl })
        },
        resolveSmileLogoDisplay(index, url) {
            const display = this.deferredImageDisplay(`smileLogo_${index}`, url)
            return display ? this.deferredImageResolve(`smileLogo_${index}`, url) : ''
        },
        resolveSmileLogoPreview(url) {
            if (!url) return '';
            if (/^https?:\/\//i.test(url)) return url;
            return this.$resolveImageSrc(url);
        },
        /** 档位行左侧色条：前 3 档绿/黄/红，其余为中性色 */
        getSmileTierAccent(index) {
            const accents = ['green', 'yellow', 'red', 'blue', 'purple'];
            return accents[index] || 'default';
        },

        // 流动红旗相关方法
        loadFlowingRedFlag(departmentId) {
            if (!departmentId) return Promise.resolve();
            return getFlowingRedFlagConfig({ departmentId }).then(res => {
                if (res && res.data && res.data.success) {
                    const resp = res.data.response || {};
                    const groups = resp.Groups || []; // 新版配置在Groups列表
                    this.form.FlowingRedFlagEnabled = resp.FlowingRedFlagEnabled !== undefined ? !!resp.FlowingRedFlagEnabled : true;

                    this.flowingGroups = groups.map((g, index) => {
                        // 将后端对象转化为前端模型
                        let targets = [];
                        if (typeof g.Target === 'string') {
                            targets = g.Target.length ? g.Target.split(',').map(s => s.trim()).filter(Boolean) : [];
                        } else if (Array.isArray(g.Target)) {
                            targets = g.Target;
                        }

                        let teacherIds = [];
                        if (typeof g.ReviewTeacherIds === 'string') {
                            teacherIds = g.ReviewTeacherIds.length ? g.ReviewTeacherIds.split(',').map(s => s.trim()).filter(Boolean) : [];
                        } else if (Array.isArray(g.ReviewTeacherIds)) {
                            teacherIds = g.ReviewTeacherIds;
                        }

                        return {
                            GroupId: g.GroupId || '',
                            GroupName: g.GroupName || `分组${index + 1}`,
                            Mode: g.Mode !== undefined ? g.Mode : 0,
                            Scope: g.Scope !== undefined ? g.Scope : 0,
                            ScopeTargets: targets,
                            Percent: g.Percent !== undefined ? g.Percent : 10,
                            IncludeTies: !!g.IncludeTies,
                            PushWeekDay: g.PushWeekDay || 7,
                            PushDayOfMonth: (g.PushDayOfMonth !== undefined && g.PushDayOfMonth !== null) ? g.PushDayOfMonth : 0,
                            PushTime: g.PushTime || '08:00',
                            ReviewTeacherIds: teacherIds,
                            IsAutoPush: g.IsAutoPush !== undefined ? g.IsAutoPush : true, // 默认开启定时评选
                            TaskId: g.TaskId || null
                        };
                    });

                    this.mapAllGroupsTargets();
                    this.ensureFrfGroupPageInRange();
                }
            }).catch((e) => {
                console.error(e);
                this.$message && this.$message.error && this.$message.error('加载流动红旗配置失败');
            });
        },

        saveFlowingRedFlag() {
            if (!this.DepartmentId) {
                this.$message.warning('请先选择部门');
                return Promise.reject();
            }
            this.savingFlow = true;

            // 构建分组列表
            const groupsParams = this.flowingGroups.map(g => {
                let targetsValue = '';
                if (Array.isArray(g.ScopeTargets)) {
                    // 兼容级联选择器路径数组 [id1, id2, targetId] 或单 ID
                    const arr = g.ScopeTargets.map(item => {
                        if (Array.isArray(item)) return item[item.length - 1];
                        return item;
                    }).filter(Boolean);
                    targetsValue = arr.join(',');
                } else {
                    targetsValue = g.ScopeTargets || '';
                }

                let teacherIdsValue = '';
                if (Array.isArray(g.ReviewTeacherIds)) {
                    teacherIdsValue = g.ReviewTeacherIds.join(',');
                } else {
                    teacherIdsValue = g.ReviewTeacherIds || '';
                }

                return {
                    GroupId: g.GroupId || '',
                    GroupName: g.GroupName || '',
                    Mode: Number(g.Mode),
                    Scope: Number(g.Scope),
                    Target: targetsValue,
                    Percent: Number(g.Percent),
                    IncludeTies: !!g.IncludeTies,
                    PushWeekDay: Number(g.PushWeekDay),
                    PushDayOfMonth: Number(g.PushDayOfMonth),
                    PushTime: g.PushTime || '08:00',
                    ReviewTeacherIds: teacherIdsValue,
                    IsAutoPush: !!g.IsAutoPush
                };
            });

            const payload = {
                departmentId: this.DepartmentId,
                Groups: groupsParams,
                FlowingRedFlagEnabled: !!this.form.FlowingRedFlagEnabled
            };

            return setFlowingRedFlagConfig(payload).then(res => {
                this.savingFlow = false;
                if (res && res.data && res.data.success) {
                    this.$message.success('配置已更新');
                    this.loadFlowingRedFlag(this.DepartmentId);
                    return Promise.resolve();
                } else {
                    this.$message.error((res && res.data && res.data.msg) || '保存失败');
                    return Promise.reject();
                }
            }).catch((e) => {
                this.savingFlow = false;
                this.$message.error('保存失败，请稍后重试');
                return Promise.reject(e);
            });
        },

        // Group CRUD
        handleCreateGroup() {
            this.resetTempGroup();
            this.dialogTitle = '新增评选分组';
            this.editGroupIndex = -1;
            this.dialogGroupVisible = true;
        },
        /** 搜索/筛选变化时回到第 1 页。创建于 2026-03-16 */
        onFrfGroupFilterChange() {
            this.frfGroupPage = 1;
        },
        onFrfGroupPageSizeChange() {
            this.frfGroupPage = 1;
        },
        /** 表格序号：跨页连续编号 */
        frfGroupTableIndex(index) {
            const size = this.frfGroupPageSize || 10;
            const page = Math.max(1, this.frfGroupPage || 1);
            return (page - 1) * size + index + 1;
        },
        /** 根据行对象解析在 flowingGroups 中的真实下标 */
        resolveFlowingGroupIndex(row) {
            if (!row) return -1;
            const byRef = this.flowingGroups.indexOf(row);
            if (byRef > -1) return byRef;
            if (row.GroupId) {
                return this.flowingGroups.findIndex(item => item && item.GroupId === row.GroupId);
            }
            return this.flowingGroups.findIndex(item => item && item.GroupName === row.GroupName);
        },
        /** 删除后若当前页为空则回退一页 */
        ensureFrfGroupPageInRange() {
            const size = this.frfGroupPageSize || 10;
            const maxPage = Math.max(1, Math.ceil((this.filteredFlowingGroups.length || 0) / size) || 1);
            if (this.frfGroupPage > maxPage) this.frfGroupPage = maxPage;
        },
        handleEditGroup(row) {
            const index = this.resolveFlowingGroupIndex(row);
            if (index < 0) {
                this.$message.warning('未找到该分组，请刷新后重试');
                return;
            }
            this.editGroupIndex = index;
            this.dialogTitle = '编辑评选分组';
            this.tempGroup = JSON.parse(JSON.stringify(this.flowingGroups[index]));
            this.dialogGroupVisible = true;
        },
        handleDeleteGroup(row) {
            const index = this.resolveFlowingGroupIndex(row);
            if (index < 0) {
                this.$message.warning('未找到该分组，请刷新后重试');
                return;
            }
            this.$confirm('确定要删除该分组配置吗？删除后将立即保存。', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.flowingGroups.splice(index, 1);
                this.ensureFrfGroupPageInRange();
                this.saveFlowingRedFlag().catch(() => {
                    this.$message.error('删除保存失败，请刷新页面检查');
                });
            }).catch(() => { });
        },
        saveGroupData() {
            if (this.editGroupIndex > -1) {
                // Update
                this.$set(this.flowingGroups, this.editGroupIndex, JSON.parse(JSON.stringify(this.tempGroup)));
            } else {
                // Add
                this.flowingGroups.push(JSON.parse(JSON.stringify(this.tempGroup)));
            }
            // Trigger auto save
            this.saveFlowingRedFlag().then(() => {
                this.dialogGroupVisible = false;
            });
        },
        resetTempGroup() {
            this.tempGroup = {
                GroupId: '',
                GroupName: `分组${this.flowingGroups.length + 1}`,
                Mode: 0,
                Scope: 0,
                ScopeTargets: [],
                Percent: 10,
                IncludeTies: false,
                PushWeekDay: 7,
                PushDayOfMonth: 0,
                PushTime: '08:00',
                ReviewTeacherIds: [],
                IsAutoPush: true,
                TaskId: null
            };
        },

        // Helper Display Methods
        getWeekDayLabel(val) {
            const day = this.weekDays.find(d => d.value == val);
            return day ? day.label : val;
        },
        getMonthDayLabel(val) {
            if (val === 0) return '首日';
            if (val === -1) return '末日';
            return val + '日';
        },
        getTeacherNames(ids) {
            if (!ids || !ids.length) return '';
            const names = [];
            ids.forEach(id => {
                const t = this.teacherMasterList.find(tm => tm.Id == id);
                if (t) names.push(t.TeacherName);
            });
            return names.join(', ');
        },

        // Load sub-departments
        loadSubDepartments(departmentId) {
            if (!departmentId) return Promise.resolve();
            return getSubDepartmentTree({ pid: departmentId, type: 1 }).then(res => {
                if (res && res.data && res.data.response) {
                    const tree = res.data.response;
                    this.classOptionsTree = Array.isArray(tree) ? tree : [tree];
                    this.mapAllGroupsTargets();
                } else {
                    this.classOptionsTree = [];
                }
            }).catch(() => {
                this.classOptionsTree = [];
            });
        },

        // Flatten nodes (unchanged)
        flattenNodes(nodes) {
            const out = [];
            const walk = (arr) => {
                if (!Array.isArray(arr)) return;
                arr.forEach(n => {
                    if (!n) return;
                    const val = n.value !== undefined ? n.value : (n.Id !== undefined ? n.Id : (n.id !== undefined ? n.id : null));
                    const lab = n.label !== undefined ? n.label : (n.Name || n.name || n.Label || (val !== null ? String(val) : ''));
                    if (val !== null) {
                        out.push({ value: val, label: lab });
                    }
                    if (n && Array.isArray(n.children) && n.children.length) {
                        walk(n.children);
                    }
                });
            };
            if (Array.isArray(nodes)) {
                walk(nodes);
            } else if (nodes && typeof nodes === 'object') {
                walk([nodes]);
            }
            return out;
        },

        // Find path (unchanged)
        findPathInTree(value) {
            const tree = this.classOptionsTree || [];
            const path = [];
            let found = false;
            const dfs = (nodes, curPath) => {
                if (!Array.isArray(nodes) || found) return;
                for (let n of nodes) {
                    if (!n) continue;
                    const val = n.value !== undefined ? n.value : (n.Id !== undefined ? n.Id : (n.id !== undefined ? n.id : null));
                    const nextPath = curPath.concat([val]);
                    if (String(val) === String(value)) {
                        path.push(...nextPath);
                        found = true;
                        return;
                    }
                    if (n.children && n.children.length) {
                        dfs(n.children, nextPath);
                        if (found) return;
                    }
                }
            };
            dfs(tree, []);
            return found ? path : null;
        },

        // Update: Map targets for ALL groups
        mapAllGroupsTargets() {
            if (!this.classOptionsTree || !this.classOptionsTree.length) return;
            if (!this.flowingGroups || !this.flowingGroups.length) return;

            this.flowingGroups.forEach(group => {
                this.mapGroupTargets(group);
            });
        },

        // Map single group targets
        mapGroupTargets(group) {
            const targets = group.ScopeTargets || [];
            if (!targets || !targets.length) return;
            // First type check
            const firstType = typeof targets[0];
            if (targets.length && (firstType === 'string' || firstType === 'number')) {
                const mapped = [];
                targets.forEach(id => {
                    const p = this.findPathInTree(id);
                    if (p) mapped.push(p);
                });
                // Only update if we found mappings, otherwise keep original IDs which might be handled if tree not fully loaded?
                // Actually if mapped is empty and targets is not, it means we couldn't find them in tree.
                if (mapped.length) {
                    group.ScopeTargets = mapped;
                }
            }
        },

        // 德育新功能辅助方法
        handleManageTeacherGroups() {
            this.teacherLimitPage = 1;
            this.teacherLimitVisible = true;
        },
        /** 添加限额组并跳到末页。创建于 2026-09-05 */
        addTeacherLimitGroup() {
            if (this.teacherLimitGroups.length < 20) {
                this.teacherLimitGroups.push({ GroupName: '', TeacherIds: [], Period: 'Week', MaxScore: 100 });
                const size = this.teacherLimitPageSize || 8;
                this.teacherLimitPage = Math.max(1, Math.ceil(this.teacherLimitGroups.length / size));
            }
        },
        /** 按当前页下标删除限额组。创建于 2026-09-05 */
        removeTeacherLimitGroup(pageIndex) {
            const size = this.teacherLimitPageSize || 8;
            const page = Math.max(1, this.teacherLimitPage || 1);
            const realIndex = (page - 1) * size + pageIndex;
            if (realIndex < 0 || realIndex >= this.teacherLimitGroups.length) return;
            this.teacherLimitGroups.splice(realIndex, 1);
            const maxPage = Math.max(1, Math.ceil(this.teacherLimitGroups.length / size) || 1);
            if (this.teacherLimitPage > maxPage) this.teacherLimitPage = maxPage;
        },
        confirmTeacherLimitGroups() {
            this.teacherLimitVisible = false;
        }
    },
};
</script>

<style scoped>
.config-panel {
    /* 德育配置统一设计令牌。最后更新：2026-03-16 */
    --mc-bg: #f5f7fa;
    --mc-surface: #ffffff;
    --mc-surface-soft: #f8fafc;
    --mc-surface-item: #ffffff;
    --mc-border: #e5e7eb;
    --mc-border-soft: #eef2f7;
    --mc-text: #0f172a;
    --mc-text-secondary: #475569;
    --mc-muted: #64748b;
    --mc-primary: var(--btn-primary, #2563eb);
    --mc-primary-soft: rgba(37, 99, 235, 0.08);
    --mc-primary-ring: rgba(37, 99, 235, 0.16);
    --mc-accent-general: #2563eb;
    --mc-accent-class: #d97706;
    --mc-accent-student: #0d9488;
    --mc-accent-rule: #ea580c;
    --mc-accent-action: #7c3aed;
    --mc-accent-points: #059669;
    --mc-accent-mode: #2563eb;
    --mc-radius: 10px;
    --mc-radius-sm: 8px;
    --mc-gap: 12px;
    --mc-shadow-sm: 0 1px 2px rgba(15, 23, 42, 0.04);
    --mc-shadow-card: 0 1px 2px rgba(15, 23, 42, 0.03);
    --mc-transition: 0.2s ease;
    flex: 1 1 auto;
    min-height: 0;
    width: 100%;
    max-width: 1180px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    color: var(--mc-text-secondary);
}

@media screen and (min-width: 769px) {
    .config-panel {
        height: 0;
    }
}

.config-content {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding-bottom: 8px;
}

.config-page-head {
    flex-shrink: 0;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 12px;
    padding: 4px 2px 12px;
    border-bottom: 1px solid var(--mc-border);
}

.config-page-head__eyebrow {
    display: block;
    font-size: 12px;
    color: var(--mc-muted);
    margin-bottom: 4px;
    letter-spacing: 0.02em;
}

.config-page-head__title {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: var(--mc-text);
    line-height: 1.3;
}

.config-page-head__hint {
    margin: 0;
    font-size: 12px;
    color: var(--mc-muted);
    white-space: nowrap;
}

.moral-config-tabs {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: transparent;
}

.moral-config-tabs ::v-deep .el-tabs__header {
    flex-shrink: 0;
    margin: 0 0 12px;
    background: var(--mc-surface);
    padding: 0 4px;
    border: 1px solid var(--mc-border);
    border-radius: var(--mc-radius);
}

.moral-config-tabs ::v-deep .el-tabs__nav-wrap::after {
    height: 1px;
    background-color: var(--mc-border-soft);
}

/* 分栏等宽居中。最后修改：2026-03-16 */
.moral-config-tabs ::v-deep .el-tabs__item {
    height: 40px;
    line-height: 40px;
    padding: 0 8px;
    font-size: 14px;
    font-weight: 500;
    color: var(--mc-muted);
    text-align: center;
    transition: color var(--mc-transition);
}

.moral-config-tabs ::v-deep .el-tabs__nav.is-stretch > .el-tabs__item {
    flex: 1;
}

.moral-config-tabs ::v-deep .el-tabs__item:hover {
    color: var(--mc-primary);
}

.moral-config-tabs ::v-deep .el-tabs__item.is-active {
    color: var(--mc-primary);
    font-weight: 600;
}

.moral-config-tabs ::v-deep .el-tabs__active-bar {
    height: 3px;
    border-radius: 2px 2px 0 0;
    background-color: var(--mc-primary);
}

.moral-config-tabs ::v-deep .el-tabs__content {
    flex: 1 1 auto;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
}

.moral-config-tabs ::v-deep .el-tab-pane {
    height: auto;
}

.config-card {
    border-radius: var(--mc-radius);
    border: 1px solid var(--mc-border);
    box-shadow: none;
    background: var(--mc-surface);
}

.config-card ::v-deep .el-card__header {
    padding: 12px 16px;
    border-bottom: 1px solid var(--mc-border-soft);
    background: var(--mc-surface-soft);
}

.config-card ::v-deep .el-card__body {
    padding: 14px 16px 16px;
}

.mc-section-row {
    margin-bottom: var(--mc-gap);
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0;
    gap: 12px;
}

.card-header .title {
    font-size: 15px;
    font-weight: 600;
    color: var(--mc-text);
    border-left: 3px solid var(--mc-primary);
    padding-left: 10px;
    line-height: 1.2;
    display: inline-flex;
    align-items: center;
}

.card-header .actions {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
}

/* 状态条 */
.status-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f4f4f5;
    padding: 12px 20px;
    border-radius: 6px;
    margin-bottom: 20px;
    transition: all 0.3s;
}

.status-bar.is-active {
    background-color: #f0f9eb;
}

.status-left {
    display: flex;
    align-items: center;
}

.status-left .label {
    font-weight: 500;
    margin-right: 10px;
    color: #606266;
}

.status-desc {
    font-size: 13px;
    color: #909399;
}

.is-active .status-desc {
    color: #67c23a;
}

.sub-section {
    margin-bottom: var(--mc-gap);
}

.sub-section:last-child {
    margin-bottom: 0;
}

.section-title {
    font-size: 13px;
    color: var(--mc-text-secondary);
    font-weight: 600;
    margin-bottom: 8px;
    padding-left: 2px;
}

.section-title i {
    margin-right: 5px;
    font-size: 15px;
    vertical-align: middle;
}

.section-title .el-icon-s-flag {
    color: #F56C6C;
}

.section-title .el-icon-s-tools {
    color: var(--btn-primary, #2563eb);
}

/* 评选分组弹窗：使用 el-card 分区 */
.group-config-dialog-card {
    border-radius: 4px;
}

.group-config-dialog-card--spaced {
    margin-top: 14px;
}

.group-config-dialog-card ::v-deep .el-card__header {
    padding: 10px 16px;
}

.group-config-dialog-card__header {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 600;
    color: #303133;
}

.group-config-dialog-card__icon {
    margin-right: 12px;
    font-size: 16px;
}

.group-config-dialog-card__icon--flag {
    color: #f56c6c;
}

.group-config-dialog-card__icon--time {
    color: var(--btn-primary, #2563eb);
}

/* 内部小卡片：统一表面 + 左边色条区分模块。最后更新：2026-03-16 */
.inner-card {
    border-radius: var(--mc-radius-sm);
    padding: 12px 14px;
    border: 1px solid var(--mc-border);
    border-left-width: 3px;
    border-left-color: var(--mc-border);
    transition: border-color var(--mc-transition), box-shadow var(--mc-transition);
    background-color: var(--mc-surface-soft);
    min-height: 0;
    display: flex;
    flex-direction: column;
    box-shadow: var(--mc-shadow-card);
}

.inner-card.is-disabled {
    filter: grayscale(0.2);
    opacity: 0.85;
    background: #fafafa !important;
    border-color: var(--mc-border) !important;
}

.inner-title {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
    padding-bottom: 8px;
    font-size: 14px;
    font-weight: 600;
    color: var(--mc-text);
    border-bottom: 1px solid var(--mc-border-soft);
    line-height: 1.3;
}

.inner-title i {
    font-size: 16px;
    color: var(--mc-primary);
}

.inner-title-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid var(--mc-border-soft);
}

.inner-title-content {
    font-size: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;
    color: var(--mc-text);
}

.inner-title-content i {
    margin-right: 8px;
    font-size: 16px;
    color: var(--mc-primary);
}

/* 各模块浅底 + 左边色条 */
.general-bg,
.class-bg,
.student-bg,
.points-bg,
.rule-bg,
.action-bg,
.mode-bg {
    background: var(--mc-surface-soft);
    border-color: var(--mc-border);
}

.general-bg { border-left-color: var(--mc-accent-general); }
.class-bg { border-left-color: var(--mc-accent-class); }
.student-bg { border-left-color: var(--mc-accent-student); }
.rule-bg { border-left-color: var(--mc-accent-rule); }
.action-bg { border-left-color: var(--mc-accent-action); }
.points-bg { border-left-color: var(--mc-accent-points); }
.mode-bg { border-left-color: var(--mc-accent-mode); }

.growth-tree-panel,
.duty-inspect-smile-schedule-card,
.duty-inspect-smile-tier-card {
    border-left-color: var(--mc-primary);
}

.general-bg .inner-title i,
.mode-bg .inner-title i { color: var(--mc-accent-general); }
.class-bg .inner-title i { color: var(--mc-accent-class); }
.student-bg .inner-title i { color: var(--mc-accent-student); }
.rule-bg .inner-title-content i { color: var(--mc-accent-rule); }
.action-bg .inner-title-content i { color: var(--mc-accent-action); }
.points-bg .inner-title i { color: var(--mc-accent-points); }

.moral-points-card {
    border: 1px solid var(--mc-border, #e4e7ed);
}

.moral-points-alert {
    margin-bottom: 14px;
    border-radius: 10px;
}

.points-panel {
    min-height: 0;
    border-radius: var(--mc-radius-sm);
    box-shadow: var(--mc-shadow-card);
}

.moral-points-form .el-form-item__label {
    color: var(--mc-text-secondary);
    font-weight: 500;
}

.moral-time-picker {
    width: 120px;
}

.moral-task-text {
    line-height: 1.8;
}

.moral-grid {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.moral-grid-row {
    display: flex;
    gap: 12px;
}

.moral-grid-item {
    flex: 1;
    min-width: 0;
    min-height: 38px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    gap: 8px;
    padding: 10px 12px;
    border: 1px solid var(--mc-border);
    border-radius: var(--mc-radius-sm);
    background: var(--mc-surface-item);
    box-shadow: var(--mc-shadow-sm);
}

.moral-grid-item__main {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    width: 100%;
    min-width: 0;
    flex: 0 0 auto;
}

.moral-grid-item__main > .moral-item-label {
    flex-shrink: 0;
}

.moral-grid-item .el-radio-group {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px 14px;
}

.mc-radio-pair.el-radio-group {
    gap: 4px 16px;
}

.mc-radio-pair .el-radio {
    margin-right: 0 !important;
}

.mc-radio-pair .el-radio__label {
    padding-left: 8px;
}

.moral-grid-item .el-radio {
    margin-right: 0;
}

.moral-grid-item .el-radio__label {
    padding-left: 6px;
}

.moral-grid-item .el-switch {
    flex-shrink: 0;
}

.moral-grid-item .el-switch .el-switch__label {
    white-space: nowrap;
}

.moral-grid-item .el-switch .el-switch__label * {
    font-size: 12px;
}

.moral-grid-item--tip {
    justify-content: flex-start;
}

.mc-item-hint {
    display: block;
    box-sizing: border-box;
    margin: 0;
    width: 100%;
    padding: 7px 10px;
    font-size: 12px;
    line-height: 1.55;
    color: var(--mc-text-secondary);
    background: var(--mc-surface-soft);
    border: 1px solid var(--mc-border-soft);
    border-left: 3px solid var(--mc-primary);
    border-radius: 0 var(--mc-radius-sm) var(--mc-radius-sm) 0;
}

.mc-item-hint--block {
    margin: 0 0 12px;
}

.mc-section-hints {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin: 0 0 12px;
}

.mc-section-hints .mc-item-hint {
    border-left-color: var(--mc-primary);
}

.basic-grid-item .mc-item-hint {
    grid-column: 1 / -1;
    margin-top: 2px;
}

.moral-grid-item > .mc-item-hint {
    flex: 0 0 auto;
    align-self: stretch;
}

.el-form-item .mc-item-hint {
    margin-top: 6px;
}

.zs-mode-form-item {
    margin-bottom: 0;
}

.zs-mode-cards {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--mc-gap);
    width: 100%;
}

.zs-mode-card {
    position: relative;
    box-sizing: border-box;
    padding: 14px 14px 12px;
    background: var(--mc-surface);
    border: 1px solid var(--mc-border);
    border-radius: var(--mc-radius);
    cursor: pointer;
    transition: border-color var(--mc-transition), box-shadow var(--mc-transition), background-color var(--mc-transition);
    outline: none;
}

.zs-mode-card:hover {
    border-color: #93c5fd;
    background: var(--mc-primary-soft);
}

.zs-mode-card:focus-visible {
    border-color: var(--mc-primary);
    box-shadow: 0 0 0 3px var(--mc-primary-ring);
}

.zs-mode-card.is-active {
    border-color: var(--mc-primary);
    background: linear-gradient(180deg, var(--mc-primary-soft) 0%, var(--mc-surface) 70%);
    box-shadow: var(--mc-shadow-sm), 0 8px 18px var(--mc-primary-ring);
}

.zs-mode-card__head {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 12px;
    padding-bottom: 10px;
    border-bottom: 1px solid var(--mc-border-soft);
}

.zs-mode-card.is-active .zs-mode-card__head {
    border-bottom-color: #dbeafe;
}

.zs-mode-card__radio {
    flex: 0 0 auto;
    width: 16px;
    height: 16px;
    margin-top: 2px;
    border: 2px solid #cbd5e1;
    border-radius: 50%;
    background: #fff;
    box-sizing: border-box;
    transition: border-color var(--mc-transition), box-shadow var(--mc-transition);
}

.zs-mode-card.is-active .zs-mode-card__radio {
    border-color: var(--mc-primary);
    box-shadow: inset 0 0 0 4px var(--mc-primary);
}

.zs-mode-card__titles {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px 8px;
    min-width: 0;
}

.zs-mode-card__title {
    font-size: 14px;
    font-weight: 600;
    line-height: 1.3;
    color: var(--mc-text);
}

.zs-mode-card__badge {
    display: inline-flex;
    align-items: center;
    height: 20px;
    padding: 0 7px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 500;
    line-height: 1;
    color: var(--mc-text-secondary);
    background: var(--mc-surface-soft);
    border: 1px solid var(--mc-border);
}

.zs-mode-card__badge--alt,
.zs-mode-card.is-active .zs-mode-card__badge {
    color: var(--mc-primary);
    background: var(--mc-primary-soft);
    border-color: #bfdbfe;
}

.zs-mode-card__steps {
    margin: 0;
    padding: 0;
    list-style: none;
}

.zs-mode-card__steps li {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin: 0;
    padding: 4px 0;
    font-size: 12px;
    line-height: 1.55;
    color: var(--mc-text-secondary);
}

.zs-step-no {
    flex: 0 0 auto;
    width: 18px;
    height: 18px;
    margin-top: 1px;
    border-radius: 50%;
    background: var(--mc-surface-soft);
    color: var(--mc-muted);
    font-size: 11px;
    font-weight: 600;
    line-height: 18px;
    text-align: center;
}

.zs-mode-card.is-active .zs-step-no {
    background: var(--mc-primary-soft);
    color: var(--mc-primary);
}

@media (max-width: 900px) {
    .zs-mode-cards {
        grid-template-columns: 1fr;
    }
}

@media (prefers-reduced-motion: reduce) {
    .zs-mode-card,
    .inner-card,
    .moral-config-tabs ::v-deep .el-tabs__item {
        transition: none;
    }
}

.inner-card > .mc-item-hint {
    margin-top: 8px;
}

.moral-ratio-item {
    width: 100%;
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
}

.moral-ratio-grid {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 10px 12px;
}

.moral-ratio-card {
    border: 1px solid var(--mc-border);
    border-radius: var(--mc-radius-sm);
    padding: 7px 10px;
    background: var(--mc-surface-item);
    flex: 0 0 auto;
    width: auto;
    min-width: 128px;
    max-width: none;
    box-shadow: var(--mc-shadow-sm);
}

.moral-ratio-name {
    display: block;
    margin-bottom: 4px;
    color: var(--mc-text-secondary);
    font-size: 12px;
    font-weight: 500;
    line-height: 1.2;
}

.moral-ratio-control {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
}

.moral-ratio-input {
    width: 108px;
}

@media (max-width: 1760px) {
    .moral-ratio-card {
        min-width: 124px;
    }
}

@media (max-width: 1520px) {
    .moral-ratio-card {
        min-width: 118px;
    }
}

.moral-ratio-text {
    display: block;
    margin-top: 6px;
}

.moral-ratio-empty {
    margin-top: 2px;
}

.moral-ratio-note {
    margin-top: 2px;
}

.moral-item-label {
    display: inline-flex;
    align-items: center;
    flex: 0 0 auto;
    min-width: auto;
    max-width: 100%;
    color: var(--mc-text-secondary);
    font-size: 13px;
    margin-right: 0;
    white-space: nowrap;
    word-break: keep-all;
    line-height: 1.35;
}

.moral-grid-note {
    margin-top: 2px;
    padding-left: 2px;
    color: #6f7f9a;
}

.moral-grid-explain {
    margin-top: -2px;
    padding: 0 2px;
    color: #5f6f8a;
    line-height: 1.5;
}

.moral-task-row {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 8px 10px;
    border: 1px dashed #d9e7fb;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.6);
}

.task-pill {
    display: inline-block;
    margin-right: 8px;
    padding: 2px 8px;
    border-radius: 999px;
    background: #f3f8ff;
    border: 1px solid #dbe9ff;
}

.task-pill code {
    font-size: 12px;
    color: #2f5f9e;
    background: transparent;
    padding: 0;
}

.basic-grid {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.basic-grid-row {
    display: flex;
    gap: 10px;
}

.basic-grid-item {
    flex: 1;
    min-width: 0;
    display: grid;
    grid-template-columns: 96px minmax(0, 1fr);
    align-items: center;
    gap: 8px 10px;
    padding: 10px 12px;
    border: 1px solid var(--mc-border);
    border-radius: var(--mc-radius-sm);
    background: var(--mc-surface-item);
    box-shadow: var(--mc-shadow-sm);
}

.basic-grid-item--full {
    grid-template-columns: 96px minmax(0, 1fr);
}

.basic-item-label {
    display: inline-flex;
    align-items: center;
    color: var(--mc-text-secondary);
    font-size: 13px;
    white-space: nowrap;
}

.basic-item-control {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
}

.basic-item-tip {
    font-size: 12px;
    color: var(--mc-muted);
    line-height: 1.35;
}

/* 辅助样式 */
.flex-row {
    display: flex;
    align-items: center;
}

.flex-col {
    display: flex;
    flex-direction: column;
}

.prefix {
    color: var(--mc-text-secondary);
    margin-right: 5px;
}

/* Compact Styles Merged */
.compact-card {
    padding: 12px 14px !important;
}

.compact-title {
    margin-bottom: 12px !important;
    padding-bottom: 8px !important;
    font-size: 14px !important;
}

.compact-form .el-form-item {
    margin-right: 15px;
    margin-bottom: 0 !important;
}

.info-text {
    font-size: 12px;
    color: var(--mc-muted);
}

.tip-xs {
    font-size: 12px;
    transform: scale(0.9);
    transform-origin: left top;
}

.loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    min-height: 400px;
}

.loading-text {
    color: var(--mc-muted);
    font-size: 14px;
    margin-top: 10px;
}

.no-department-tip {
    /* background-color: #fff; */
    border-radius: 4px;
    /* padding: 60px 20px; */
    text-align: center;
    color: #909399;
    /* border: 1px solid #e8e8e8; */
    min-height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.is-disabled-content {
    opacity: 0.5;
    pointer-events: none;
    filter: grayscale(1);
    transition: all 0.3s;
}

.tip-text {
    font-size: 12px;
    color: var(--mc-muted);
    line-height: 1.45;
    margin-top: 4px;
}

.mc-info-icon {
    margin-left: 4px;
    font-size: 14px;
    color: #909399;
    cursor: pointer;
    vertical-align: middle;
    transition: color 0.2s ease;
}

.mc-info-icon:hover {
    color: var(--btn-primary, #2563eb);
}

.mc-tip-content {
    max-width: 320px;
    line-height: 1.5;
    font-size: 12px;
}

.mc-tip-content > div + div {
    margin-top: 6px;
}

.flowing-red-flag-tip {
    margin: 0 0 12px;
    line-height: 1.4;
}

.frf-card-header {
    flex-wrap: wrap;
    row-gap: 8px;
}

.frf-header-actions {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
}

.frf-switch-label {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: var(--mc-text-secondary, #475569);
    margin-left: 4px;
}

.frf-head-hints {
    margin-bottom: 10px;
}

.frf-search-input {
    width: 200px;
}

.frf-mode-filter {
    width: 110px;
}

/* 与班级池分页一致：整组靠右 */
.frf-pagination {
    flex: 0 0 auto;
    width: 100%;
    margin-top: 12px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.frf-pagination ::v-deep .el-pagination {
    white-space: nowrap;
}

/* 固定高度表格：保证表体可纵向滚动。最后更新：2026-03-16 */
.frf-groups-table ::v-deep .el-table__body-wrapper {
    overflow-x: auto !important;
    overflow-y: auto !important;
}

.frf-groups-table ::v-deep .el-table__body td {
    padding-top: 10px;
    padding-bottom: 10px;
}

.frf-groups-table ::v-deep .el-table__body td .cell {
    line-height: normal;
}

.frf-op-actions {
    display: inline-flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    gap: 6px;
    white-space: nowrap;
    line-height: 1;
    vertical-align: middle;
}

.frf-op-btn {
    padding: 5px 8px;
    margin: 0 !important;
    height: 28px;
    line-height: 1 !important;
}

.flowing-red-flag-card ::v-deep .el-card__body {
    padding-top: 12px;
    padding-bottom: 14px;
}

.flowing-red-flag-card .tip-text.flowing-red-flag-tip {
    margin-top: 0;
}

@media (max-width: 960px) {
    .config-page-head {
        flex-direction: column;
        align-items: flex-start;
    }

    .config-page-head__hint {
        white-space: normal;
    }
}

/* 覆盖 Cascader 宽度 */
.el-cascader {
    width: 100%;
}

@media (max-width: 1680px) {
    .moral-points-card .el-row {
        margin-left: 0 !important;
        margin-right: 0 !important;
    }

    .moral-points-card .el-row>[class*="el-col-"] {
        width: 100% !important;
        max-width: 100% !important;
        flex: 0 0 100% !important;
        padding-left: 0 !important;
        padding-right: 0 !important;
        margin-bottom: 10px;
    }

    .points-panel {
        min-height: auto;
    }

    .moral-grid {
        gap: 8px;
    }

    .moral-grid-row {
        flex-direction: column;
        gap: 8px;
    }

    .moral-grid-item {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: initial;
        gap: 6px;
        padding: 10px 12px;
    }

    .moral-grid-item__main {
        display: grid;
        grid-template-columns: max-content minmax(120px, 1fr);
        align-items: center;
        gap: 10px 16px;
        width: 100%;
    }

    .moral-grid-item .moral-item-label,
    .moral-grid-item__main .moral-item-label {
        white-space: nowrap;
        word-break: keep-all;
    }

    .moral-grid-item__main .el-switch,
    .moral-grid-item__main .el-select,
    .moral-grid-item__main .el-time-picker,
    .moral-grid-item__main .el-input-number,
    .moral-grid-item__main .el-radio-group,
    .moral-grid-item .el-switch,
    .moral-grid-item .el-select,
    .moral-grid-item .el-time-picker,
    .moral-grid-item .el-input-number,
    .moral-grid-item .el-radio-group {
        width: auto;
        max-width: 100%;
        justify-self: start;
    }

    /* 开关禁止拉满宽度，否则 active/inactive 文案会重叠 */
    .moral-grid-item .el-switch,
    .moral-grid-item__main .el-switch {
        width: auto !important;
        justify-self: start;
    }

    .moral-grid-item--tip {
        grid-template-columns: 1fr;
    }

    .moral-grid-item--tip .tip-text {
        margin-top: 0;
    }

    .moral-ratio-item {
        display: flex;
        grid-template-columns: none;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 8px;
    }

    .moral-ratio-card {
        width: auto;
        max-width: none;
        min-width: 124px;
    }

    .moral-task-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 6px;
    }
}

@media (max-width: 1366px) {
    .config-panel {
        max-width: 100%;
        padding: 0 8px;
    }

    .card-header {
        align-items: flex-start;
        flex-wrap: wrap;
        gap: 8px;
    }

    .card-header .actions {
        width: 100%;
        display: flex;
        justify-content: flex-end;
    }

    .config-content .el-row {
        margin-left: 0 !important;
        margin-right: 0 !important;
    }

    .config-content .el-row>[class*="el-col-"] {
        width: 100% !important;
        max-width: 100% !important;
        flex: 0 0 100% !important;
        margin-bottom: 10px;
        padding-left: 0 !important;
        padding-right: 0 !important;
    }

    .inner-card {
        min-height: auto;
    }

    .moral-grid-row {
        flex-direction: column;
        gap: 8px;
    }

    .moral-grid-item {
        min-height: 34px;
        grid-template-columns: 1fr;
        gap: 6px;
    }

    .moral-time-picker,
    .moral-grid-item .el-select,
    .moral-grid-item .el-input-number {
        width: 100% !important;
    }

    .moral-task-row {
        flex-direction: column;
        gap: 6px;
    }

    .basic-grid-row {
        flex-direction: column;
        gap: 8px;
    }

    .basic-grid-item,
    .basic-grid-item--full {
        grid-template-columns: 1fr;
        gap: 6px;
    }

    .basic-item-control {
        flex-wrap: wrap;
    }

    .basic-item-control .el-switch {
        margin-right: 2px;
    }
}

.duty-inspect-smile-switch-label {
    font-size: 13px;
    color: #606266;
    margin-right: 15px;
}

.duty-inspect-smile-body {
    transition: opacity 0.3s;
}

.duty-inspect-smile-intro {
    margin: 0 0 16px;
    line-height: 1.55;
}

.duty-inspect-smile-schedule-card {
    margin-bottom: 16px;
    background: linear-gradient(to bottom right, #f0f9ff, #ffffff);
    border-color: #d9ecff;
    min-height: auto;
}

.duty-inspect-smile-schedule-head {
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
    border-bottom: none !important;
}

.duty-inspect-smile-schedule-fields {
    padding: 10px 0 2px;
    margin-top: 0;
}

.duty-inspect-smile-schedule-row {
    flex-wrap: wrap;
    align-items: center;
    gap: 10px 18px;
}

.duty-inspect-smile-schedule-week {
    width: 100px;
}

.duty-inspect-smile-schedule-time {
    width: 120px;
}

.duty-inspect-smile-schedule-row__suffix {
    margin-left: 4px;
    padding-left: 6px;
    font-size: 12px;
    line-height: 1.5;
    white-space: nowrap;
    color: #909399;
}

.duty-inspect-smile-schedule-row>>>.duty-inspect-smile-schedule-time.el-date-editor,
.duty-inspect-smile-schedule-row>>>.el-date-editor.el-input {
    width: 120px !important;
}

.duty-inspect-smile-schedule-row>>>.duty-inspect-smile-schedule-time .el-input__inner,
.duty-inspect-smile-schedule-row>>>.el-date-editor .el-input__inner {
    width: 120px;
    padding-left: 30px;
    padding-right: 8px;
}

.duty-inspect-smile-schedule-off {
    margin: 0;
    padding: 10px 0 2px;
    line-height: 1.55;
}

.duty-inspect-smile-tier-card {
    min-height: auto;
    background: #fafbfc;
}

.duty-inspect-smile-tier-card>.inner-title-row {
    margin-bottom: 12px;
    padding-bottom: 10px;
}

.duty-inspect-smile-tier-hint {
    font-size: 12px;
    color: #909399;
    font-weight: normal;
}

.duty-inspect-smile-gap-tip {
    margin: 0 0 16px;
    padding: 10px 12px;
    color: #e6a23c;
    line-height: 1.55;
    background: #fdf6ec;
    border: 1px solid #faecd8;
    border-radius: 6px;
}

.duty-inspect-smile-gap-tip i {
    margin-right: 6px;
    vertical-align: -1px;
}

.duty-inspect-smile-tier-list {
    display: flex;
    flex-direction: column;
    gap: 14px;
    margin-bottom: 14px;
}

.duty-inspect-smile-tier-row {
    display: flex;
    align-items: flex-end;
    gap: 14px;
    padding: 14px 16px 14px 14px;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    background: #fff;
    border-left-width: 3px;
    box-sizing: border-box;
}

.duty-inspect-smile-tier-row__main {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 14px 24px;
    flex: 0 1 auto;
    min-width: 0;
}

.duty-inspect-smile-tier-row--green {
    border-left-color: #67c23a;
}

.duty-inspect-smile-tier-row--yellow {
    border-left-color: #e6a23c;
}

.duty-inspect-smile-tier-row--red {
    border-left-color: #f56c6c;
}

.duty-inspect-smile-tier-row--blue {
    border-left-color: var(--btn-primary, #2563eb);
}

.duty-inspect-smile-tier-row--purple {
    border-left-color: #a855f7;
}

.duty-inspect-smile-tier-row--default {
    border-left-color: #c0c4cc;
}

.duty-inspect-smile-tier-row__index {
    flex: 0 0 22px;
    width: 22px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    font-size: 12px;
    font-weight: 600;
    color: #909399;
    background: #f4f4f5;
    border-radius: 50%;
    margin-bottom: 2px;
}

.duty-inspect-smile-tier-row__field {
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 0;
}

.duty-inspect-smile-tier-row__field label {
    font-size: 12px;
    color: #909399;
    line-height: 1;
}

.duty-inspect-smile-tier-row__field--name {
    flex: 0 0 108px;
    width: 108px;
}

.duty-inspect-smile-tier-row__field--range {
    flex: 0 0 auto;
}

.duty-inspect-smile-tier-row__field--weight {
    flex: 0 0 108px;
    width: 108px;
}

.duty-inspect-smile-tier-row__field--logo {
    flex: 0 0 auto;
    align-items: center;
}

.duty-inspect-smile-range {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.duty-inspect-smile-range__sep {
    font-size: 12px;
    color: #909399;
    flex-shrink: 0;
}

.duty-inspect-smile-tier-row__remove {
    flex: 0 0 auto;
    margin-left: auto;
    margin-bottom: 4px;
    color: #f56c6c;
    padding: 4px;
}

.duty-inspect-smile-add-btn {
    display: inline-flex;
    margin-top: 4px;
}

.duty-inspect-smile-body>>>.duty-inspect-smile-number.el-input-number {
    width: 100%;
    max-width: 108px;
}

.duty-inspect-smile-body>>>.duty-inspect-smile-number .el-input,
.duty-inspect-smile-body>>>.duty-inspect-smile-number .el-input__inner {
    width: 100%;
    font-variant-numeric: tabular-nums;
}

.duty-inspect-smile-body>>>.duty-inspect-smile-number--weight {
    max-width: 108px;
}

.duty-inspect-smile-body>>>.smile-avatar-uploader {
    line-height: 0;
}

.duty-inspect-smile-body>>>.smile-avatar-uploader .el-upload {
    border: 1px dashed #dcdfe6;
    border-radius: 8px;
    cursor: pointer;
    overflow: hidden;
    transition: border-color 0.2s, box-shadow 0.2s;
    display: block;
    background: #fafafa;
}

.duty-inspect-smile-body>>>.smile-avatar-uploader .el-upload:hover {
    border-color: var(--btn-primary, #2563eb);
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.12);
}

.duty-inspect-smile-body .smile-avatar-uploader-icon {
    font-size: 16px;
    color: #909399;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    display: block;
}

.duty-inspect-smile-body .smile-avatar {
    width: 40px;
    height: 40px;
    display: block;
    object-fit: contain;
    padding: 3px;
    box-sizing: border-box;
}

.growth-tree-panel {
    min-height: auto;
    width: fit-content;
    max-width: 100%;
    background: #fafbfc;
    padding: 0 !important;
    overflow: hidden;
}

.growth-tree-grid {
    display: grid;
    grid-template-columns: 44px minmax(120px, 220px) 132px 108px;
    gap: 12px 16px;
    align-items: center;
    padding: 0 14px;
}

.growth-tree-grid--head {
    padding-top: 10px;
    padding-bottom: 8px;
    font-size: 12px;
    font-weight: 600;
    color: #909399;
    border-bottom: 1px solid #ebeef5;
}

.growth-tree-grid--head span:nth-child(3),
.growth-tree-grid--head span:nth-child(4) {
    text-align: center;
}

.growth-tree-grid--row {
    padding: 8px 14px;
    border-bottom: 1px solid #f0f2f5;
}

.growth-tree-grid--row:last-child {
    border-bottom: none;
}

.growth-tree-grid__idx {
    width: 22px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    border-radius: 50%;
    font-size: 12px;
    font-weight: 600;
    color: #fff;
    background: #22c55e;
    justify-self: center;
}

.growth-tree-grid__name>>>.el-input,
.growth-tree-grid__name>>>.el-input__inner {
    width: 100%;
}

.growth-tree-grid__score {
    justify-self: center;
}

.growth-tree-grid__score>>>.el-input-number {
    width: 132px;
}

.growth-tree-grid__tree {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
}

.growth-tree-uploader {
    display: inline-block;
    line-height: 0;
    flex-shrink: 0;
}

.growth-tree-uploader>>>.el-upload {
    border: none;
    cursor: pointer;
    display: block;
}

.growth-tree-thumb {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px dashed #dcdfe6;
    background: #fafafa;
    box-sizing: border-box;
    transition: border-color 0.2s, box-shadow 0.2s;
}

.growth-tree-uploader>>>.el-upload:hover .growth-tree-thumb {
    border-color: var(--btn-primary, #2563eb);
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.12);
}

.growth-tree-preview {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
    padding: 2px;
    box-sizing: border-box;
}

.growth-tree-reset-btn {
    padding: 0 2px !important;
    margin: 0 !important;
    line-height: 1.2 !important;
    font-size: 12px !important;
    cursor: pointer;
    flex-shrink: 0;
}

@media (max-width: 900px) {
    .growth-tree-grid {
        grid-template-columns: 36px 1fr;
        grid-template-areas:
            "idx name"
            ". score"
            ". tree";
        gap: 8px 10px;
        padding: 10px 12px;
    }

    .growth-tree-grid--head {
        display: none;
    }

    .growth-tree-grid--row {
        border: 1px solid #ebeef5;
        border-radius: 8px;
        margin-bottom: 8px;
    }

    .growth-tree-grid--row:last-child {
        margin-bottom: 0;
    }

    .growth-tree-grid__idx {
        grid-area: idx;
    }

    .growth-tree-grid__name {
        grid-area: name;
    }

    .growth-tree-grid__score {
        grid-area: score;
        justify-self: start;
    }

    .growth-tree-grid__tree {
        grid-area: tree;
        justify-content: flex-start;
    }

    .duty-inspect-smile-tier-row {
        flex-wrap: wrap;
        padding-right: 12px;
    }

    .duty-inspect-smile-tier-row__main {
        flex: 1 1 100%;
    }

    .duty-inspect-smile-tier-row__field--name,
    .duty-inspect-smile-tier-row__field--weight {
        flex: 1 1 calc(50% - 24px);
        width: auto;
    }

    .duty-inspect-smile-tier-row__remove {
        margin-left: auto;
    }
}

@media (max-width: 1024px) {
    .dp-layout {
        min-width: 0;
    }

    .dp-right {
        min-width: 0;
    }

    .compact-card {
        padding: 10px 12px !important;
    }

    .inner-title-row {
        align-items: flex-start;
        flex-wrap: wrap;
        gap: 8px;
    }

    .tip-text {
        line-height: 1.35;
    }
}

/* 窄屏或双分栏下的德育配置响应式适配：防止卡片和网格挤扁、文案堆叠 */
@media (max-width: 1100px) {
    .basic-grid-row {
        display: flex !important;
        flex-direction: column !important;
        gap: 12px !important;
    }
    .basic-grid-item {
        width: 100% !important;
        margin-bottom: 8px;
    }
    .basic-grid-item--full {
        width: 100% !important;
    }
    
    /* 强行将两个并排的卡片 el-col-12 拓宽为 100% 单列 */
    .config-panel >>> .el-col-12 {
        width: 100% !important;
        margin-bottom: 16px;
    }
    
    /* 表单项 label 响应式上下对齐 */
    .config-panel >>> .el-form-item {
        display: flex;
        flex-direction: column;
        align-items: flex-start !important;
    }
    .config-panel >>> .el-form-item__label {
        width: 100% !important;
        text-align: left !important;
        padding: 0 0 6px !important;
        line-height: 1.35 !important;
        font-weight: 600;
    }
    .config-panel >>> .el-form-item__content {
        margin-left: 0 !important;
        width: 100% !important;
    }
}
</style>